import S from "../pages/Product/style";

const data = [
    {
        category: {
            id: 0,
            name: 'FIRE HOSE CABINETS',
            imgsrc: process.env.PUBLIC_URL + '/images/category/yanginDolabi.jpg',
            content: 'Fire cabinets with semi-rigid hoses in accordance with EN 671-1 and with the lay flat hose in accordance with EN 671-2 Standard ,CE and ISO certified.',
            link: '/category/yangindolaplari/0/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'FIRE HOSE CABINETS WITH DECORATIVE GLASS DOOR',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/dekoratif_cam_kapakli_yangin_dolaplari/image-041.png',
                        process.env.PUBLIC_URL + '/images/products/dekoratif_cam_kapakli_yangin_dolaplari/image-042.png',
                        process.env.PUBLIC_URL + '/images/products/dekoratif_cam_kapakli_yangin_dolaplari/image-043.png',
                    ],
                    content: '',
                    link: '/product/0/0/dekoratif_cam_kapakli_yangin_dolaplari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>

                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position (jet, spray, shut-off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure.</li>
                                <li>36 bar explosion pressure.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel.</li>
                                <li>Electrostatic powder coated.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet</figcaption>
                            <ul>
                                <li>Made of 1.2 mm DKP sheet</li>
                                <li>Cover and reel mechanism can be fixed right or left without modification.</li>
                                <li>Electrostatic powder coated in desired RAL code.</li>
                                <li>Suitable for installation entry from bottom or top,right or left.</li>
                                <li>All with 4 mm tempered glass door.</li>
                                <li>Recessed, semi recessed or surface mounted options.</li>
                                <li>Special magnet lock system,disassambled door.</li>
                                <li>6 Kg ABC TS EN 862 EN 3-7 and CE certified fire extinguisher (optional).</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>FIRE HOSE CABINETS WITH DECORATIVE GLASS DOOR</figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_001_YD</td>
                                        <td>20 mt.</td>
                                        <td>750x900x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_002_YD</td>
                                        <td>25 mt.</td>
                                        <td>750x900x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_003_YD</td>
                                        <td>30 mt.</td>
                                        <td>750x900x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_004_YD</td>
                                        <td>20 mt.</td>
                                        <td>750x900x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_005_YD</td>
                                        <td>25 mt.</td>
                                        <td>750x900x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_006_YD</td>
                                        <td>30 mt.</td>
                                        <td>750x900x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 1,
                    name: 'FIRE HOSE CABINETS WITH EXTINGUISHER COMPARTMENT',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/tup_bolmeli_yangin_dolaplari/image-057.png',
                        process.env.PUBLIC_URL + '/images/products/tup_bolmeli_yangin_dolaplari/image-058.png',
                        process.env.PUBLIC_URL + '/images/products/tup_bolmeli_yangin_dolaplari/image-051.png',
                        process.env.PUBLIC_URL + '/images/products/tup_bolmeli_yangin_dolaplari/image-052.png',
                    ],
                    content: '',
                    link: '/product/0/1/tup_bolmeli_yangin_dolaplari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.2 mm DKP sheet.</li>
                                <li>Electrostatic powder coated in desired RAL code.</li>
                                <li>Suitable for installation entry from  top or side .</li>
                                <li>Both doors are manufactured of sheet .Extinguisher side optional with glass door .</li>
                                <li>Recessed, semi recessed or surface mounted options.</li>
                                <li>Special lock system,disassambled doors.</li>
                                <li>6 Kg ABC TS EN 862 EN 3-7 and CE certified fire extinguisher (optional).</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>RECESSED TYPE FIRE HOSE CABINETS WITH EXTINGUISHER COMPARTMENT-GLASS DOOR FEATURED </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_007_YD</td>
                                        <td>20 mt.</td>
                                        <td>980x710x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_008_YD</td>
                                        <td>25 mt.</td>
                                        <td>980x710x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_009_YD</td>
                                        <td>30 mt.</td>
                                        <td>980x710x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>

                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 2,
                    name: 'RECESSED TYPE FIRE HOSE CABINETS WITH EXTINGUISHER COMPARTMENT- MADE WITH SHEET DOORS ',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/siva_alti_tup_bolmeli_yangin_dolaplari/image-061.png',
                        process.env.PUBLIC_URL + '/images/products/siva_alti_tup_bolmeli_yangin_dolaplari/image-060.png',
                        process.env.PUBLIC_URL + '/images/products/siva_alti_tup_bolmeli_yangin_dolaplari/image-059.png',
                    ],
                    content: '',
                    link: '/product/0/2/sıva_alti_sac_kapakli_tup_bolmeli_yangin_dolaplari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.2 mm DKP sheet.</li>
                                <li>Electrostatic powder coated in desired RAL code.</li>
                                <li>Suitable for installation entry from  top or side .</li>
                                <li>Both doors are manufactured of sheet .Extinguisher side optional with glass door .</li>
                                <li>Recessed, semi recessed or surface mounted options.</li>
                                <li>Special lock system,disassambled doors.</li>
                                <li>6 Kg ABC TS EN 862 EN 3-7 and CE certified fire extinguisher (optional).</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>RECESSED TYPE FIRE HOSE CABINETS WITH EXTINGUISHER COMPARTMENT- MADE WITH SHEET DOORS </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_010_YD</td>
                                        <td>20 mt.</td>
                                        <td>980x710x220 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_011_YD</td>
                                        <td>25 mt.</td>
                                        <td>980x710x220 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_012_YD</td>
                                        <td>30 mt.</td>
                                        <td>980x710x220 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>

                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 3,
                    name: 'SURFACE MOUNTED  FIRE HOSE CABINETS WITH EXTINGUISHER COMPARTMENT',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/siva_ustu_tup_bolmeli/image-068.png',
                        process.env.PUBLIC_URL + '/images/products/siva_ustu_tup_bolmeli/image-067.png',
                        process.env.PUBLIC_URL + '/images/products/siva_ustu_tup_bolmeli/image-069.png',
                        process.env.PUBLIC_URL + '/images/products/siva_ustu_tup_bolmeli/image-070.png',
                    ],
                    content: '',
                    link: '/product/0/3/sıva_usut_tup_bolmeli_yangin_dolaplari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.2 mm DKP sheet.</li>
                                <li>Electrostatic powder coated in desired RAL code.</li>
                                <li>Suitable for installation entry from  top or side .</li>
                                <li>Reel and extinguisher compartments with 4 mm tempered glass door.</li>
                                <li>Recessed, semi recessed or surface mounted options.</li>
                                <li>Special lock system,disassambled doors.</li>
                                <li>6 Kg ABC TS EN 862 EN 3-7 and CE certified fire extinguisher (optional).</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>SURFACE MOUNTED  FIRE HOSE CABINETS WITH EXTINGUISHER COMPARTMENT</figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_013_YD</td>
                                        <td>20 mt.</td>
                                        <td>1020x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_014_YD</td>
                                        <td>25 mt.</td>
                                        <td>1020x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_015_YD</td>
                                        <td>30 mt.</td>
                                        <td>1020x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_016_YD</td>
                                        <td>20 mt.</td>
                                        <td>1020x750x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_017_YD</td>
                                        <td>25 mt.</td>
                                        <td>1020x750x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_018_YD</td>
                                        <td>35 mt.</td>
                                        <td>1020x750x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 4,
                    name: 'FIRE HOSE CABINETS WITH EXTINGUISHER IN BOTTOM – GLASS DOOR FEATURED',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/tup_altta_yatay_camli_tek_kapakli_yangin_dolabi/image-078.png',
                        process.env.PUBLIC_URL + '/images/products/tup_altta_yatay_camli_tek_kapakli_yangin_dolabi/image-077.png',
                        process.env.PUBLIC_URL + '/images/products/tup_altta_yatay_camli_tek_kapakli_yangin_dolabi/image-086.png',
                    ],
                    content: '',
                    link: '/product/0/4/tup_altta_yatay_camli_tek_kapakli_yangin_dolabi',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.2 mm DKP sheet.</li>
                                <li>Electrostatic powder coated in desired RAL code.</li>
                                <li>Suitable for installation entry from  top or side .</li>
                                <li>All with 4 mm tempered glass door.</li>
                                <li>Recessed, semi recessed or surface mounted options.</li>
                                <li>Special lock system,disassambled doors.</li>
                                <li>6 Kg ABC TS EN 862 EN 3-7 and CE certified fire extinguisher (optional).</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>FIRE HOSE CABINETS WITH EXTINGUISHER IN BOTTOM – GLASS DOOR FEATURED </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_019_YD</td>
                                        <td>20 mt.</td>
                                        <td>750x900x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_020_YD</td>
                                        <td>25 mt.</td>
                                        <td>750x900x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_021_YD</td>
                                        <td>30 mt.</td>
                                        <td>750x900x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_022_YD</td>
                                        <td>20 mt.</td>
                                        <td>710x900x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_023_YD</td>
                                        <td>25 mt.</td>
                                        <td>710x900x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_024_YD</td>
                                        <td>35 mt.</td>
                                        <td>710x900x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 5,
                    name: 'FIRE HOSE CABINETS WITH EXTINGUISHER IN BOTTOM – SHEET DOOR FEATURED',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/tup_altta_yatay_tek_kapakli_yangin_dolabi/image-095.png',
                        process.env.PUBLIC_URL + '/images/products/tup_altta_yatay_tek_kapakli_yangin_dolabi/image-088.png',
                        process.env.PUBLIC_URL + '/images/products/tup_altta_yatay_tek_kapakli_yangin_dolabi/image-096.png',
                    ],
                    content: '',
                    link: '/product/0/5/tup_altta_yatay_sac_tek_kapakli_yangin_dolabi',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.2 mm DKP sheet.</li>
                                <li>Cover and reel mechanism can be fixed right or left without modification.</li>
                                <li>Electrostatic powder coated in desired RAL code.</li>
                                <li>Suitable for installation entry from  top or side .</li>
                                <li>All with  DKP sheet door.</li>
                                <li>Recessed, semi recessed or surface mounted options.</li>
                                <li>Special lock system,disassambled doors.</li>
                                <li>6 Kg ABC TS EN 862 EN 3-7 and CE certified fire extinguisher (optional).</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>FIRE HOSE CABINETS WITH EXTINGUISHER IN BOTTOM – SHEET DOOR FEATURED</figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_025_YD</td>
                                        <td>20 mt.</td>
                                        <td>750x900x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_026_YD</td>
                                        <td>25 mt.</td>
                                        <td>750x900x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_027_YD</td>
                                        <td>30 mt.</td>
                                        <td>750x900x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_028_YD</td>
                                        <td>20 mt.</td>
                                        <td>710x900x220 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_029_YD</td>
                                        <td>25 mt.</td>
                                        <td>710x900x220 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_030_YD</td>
                                        <td>35 mt.</td>
                                        <td>710x900x220 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 6,
                    name: 'FIRE HOSE CABINETS WITH EXTINGUISHER IN VERTICAL – RECESSED TYPE',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/tüp_yanda_dikey_tek_kapakli_yangin_dolaplari/image-098.png',
                        process.env.PUBLIC_URL + '/images/products/tüp_yanda_dikey_tek_kapakli_yangin_dolaplari/image-097.png',
                        process.env.PUBLIC_URL + '/images/products/tüp_yanda_dikey_tek_kapakli_yangin_dolaplari/image-099.png',
                        process.env.PUBLIC_URL + '/images/products/tüp_yanda_dikey_tek_kapakli_yangin_dolaplari/image-100.png',
                    ],
                    content: '',
                    link: '/product/0/6/tüp_yanda_dikey_siva_alti_tek_kapakli_yangin_dolaplari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel.</li>
                                <li>Electrostatic powder coated.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.2 mm DKP sheet.</li>
                                <li>Cover and reel mechanism can be fixed right or left without modification.</li>
                                <li>Electrostatic powder coated in desired RAL code.</li>
                                <li>Suitable for installation entry from  top or side .</li>
                                <li>Reel and extinguisher compartments with 4 mm tempered glass door.</li>
                                <li>Recessed, semi recessed or surface mounted options.</li>
                                <li>Special lock system,disassambled doors.</li>
                                <li>6 Kg ABC TS EN 862 EN 3-7 and CE certified fire extinguisher (optional).</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>RECESSED TYPE FIRE HOSE CABINETS WITH EXTINGUISHER COMPARTMENT- MADE WITH SHEET DOORS </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_031_YD</td>
                                        <td>20 mt.</td>
                                        <td>900x710x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_032_YD</td>
                                        <td>25 mt.</td>
                                        <td>900x710x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_033_YD</td>
                                        <td>30 mt.</td>
                                        <td>900x710x220 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_034_YD</td>
                                        <td>20 mt.</td>
                                        <td>900x710x220 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_035_YD</td>
                                        <td>25 mt.</td>
                                        <td>900x710x220 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_036_YD</td>
                                        <td>35 mt.</td>
                                        <td>900x710x220 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 7,
                    name: 'RECESSED TYPE FIRE HOSE CABINETS WITH EXTINGUISHER COMPARTMENT-GLASS DOOR FEATURED ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/tüp_yanda_dikey_tek_kapakli_yangin_dolaplari/image-110.png',
                    process.env.PUBLIC_URL + '/images/products/tüp_yanda_dikey_tek_kapakli_yangin_dolaplari/image-107.png',
                    ],
                    content: '',
                    link: '/product/0/7/tüp_yanda_dikey_siva_ustu_tek_kapakli_yangin_dolaplari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>

                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.2 mm DKP sheet.</li>
                                <li>Cover and reel mechanism can be fixed right or left without modification.</li>
                                <li>Electrostatic powder coated in desired RAL code.</li>
                                <li>Suitable for installation entry from  top or side .</li>
                                <li>Reel and extinguisher compartments with 4 mm tempered glass door.</li>
                                <li>Recessed, semi recessed or surface mounted options.</li>
                                <li>Special lock system,disassambled doors.</li>
                                <li>6 Kg ABC TS EN 862 EN 3-7 and CE certified fire extinguisher (optional).</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>RECESSED TYPE FIRE HOSE CABINETS WITH EXTINGUISHER COMPARTMENT-GLASS DOOR FEATURED </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_037_YD</td>
                                        <td>20 mt.</td>
                                        <td>900x750x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_038_YD</td>
                                        <td>25 mt.</td>
                                        <td>900x750x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_039_YD</td>
                                        <td>30 mt.</td>
                                        <td>900x750x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_040_YD</td>
                                        <td>20 mt.</td>
                                        <td>900x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_041_YD</td>
                                        <td>25 mt.</td>
                                        <td>900x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_042_YD</td>
                                        <td>35 mt.</td>
                                        <td>900x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 8,
                    name: 'STANDART FIRE HOSE CABINETS WITH GLASS DOOR',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/cam_kapakli_standart_yangin_dolaplari/image-118.png',
                        process.env.PUBLIC_URL + '/images/products/cam_kapakli_standart_yangin_dolaplari/image-119.png',
                        process.env.PUBLIC_URL + '/images/products/cam_kapakli_standart_yangin_dolaplari/image-120.png',
                        process.env.PUBLIC_URL + '/images/products/cam_kapakli_standart_yangin_dolaplari/image-117.png',
                        process.env.PUBLIC_URL + '/images/products/cam_kapakli_standart_yangin_dolaplari/image-121.png',
                    ],
                    content: '',
                    link: '/product/0/8/cam_kapakli_standart_yangin_dolaplari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.2 mm DKP sheet.</li>
                                <li>Cover and reel mechanism can be fixed right or left without modification.</li>
                                <li>Electrostatic powder coated in desired RAL code.</li>
                                <li>Suitable for installation entry from  top or side .</li>
                                <li>All with  4 mm tempered glass door.</li>
                                <li>Recessed, semi recessed or surface mounted options.</li>
                                <li>Special lock system,disassambled doors.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>STANDART FIRE HOSE CABINETS WITH GLASS DOOR</figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_043_YD</td>
                                        <td>20 mt.</td>
                                        <td>710x710x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_044_YD</td>
                                        <td>25 mt.</td>
                                        <td>710x710x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_045_YD</td>
                                        <td>30 mt.</td>
                                        <td>710x710x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_046_YD</td>
                                        <td>20 mt.</td>
                                        <td>700x700x200 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_047_YD</td>
                                        <td>25 mt.</td>
                                        <td>750x750x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_048_YD</td>
                                        <td>35 mt.</td>
                                        <td>750x750x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 9,
                    name: 'STANDART FIRE HOSE CABINETS DKP SHEET DOOR',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/sac_kapakli_standart_yangin_dolaplari/image-128.png',
                        process.env.PUBLIC_URL + '/images/products/sac_kapakli_standart_yangin_dolaplari/image-129.png',
                        process.env.PUBLIC_URL + '/images/products/sac_kapakli_standart_yangin_dolaplari/image-136.png',
                    ],
                    content: '',
                    link: '/product/0/9/sac_kapakli_standart_yangin_dolaplari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.2 mm DKP sheet.</li>
                                <li>Cover and reel mechanism can be fixed right or left without modification.</li>
                                <li>Electrostatic powder coated in desired RAL code.</li>
                                <li>Suitable for installation entry from  top or side .</li>
                                <li>All with  DKP sheet door.</li>
                                <li>Recessed, semi recessed or surface mounted options.</li>
                                <li>Special lock system,disassambled doors.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>STANDART FIRE HOSE CABINETS DKP SHEET DOOR</figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_049_YD</td>
                                        <td>20 mt.</td>
                                        <td>710x710x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_050_YD</td>
                                        <td>25 mt.</td>
                                        <td>710x710x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_051_YD</td>
                                        <td>30 mt.</td>
                                        <td>710x710x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_052_YD</td>
                                        <td>20 mt.</td>
                                        <td>700x700x200 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_053_YD</td>
                                        <td>25 mt.</td>
                                        <td>750x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_054_YD</td>
                                        <td>35 mt.</td>
                                        <td>750x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 10,
                    name: 'OUTDOOR TYPE FIRE HOSE CABINETS WITH SEMI RIGIT HOSE',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/sulu_sistem_sahra_tipi_yangin_dolabi/image-139.png',
                        process.env.PUBLIC_URL + '/images/products/sulu_sistem_sahra_tipi_yangin_dolabi/image-138.png',
                    ],

                    content: '',
                    link: '/product/0/10/sulu_sistem_sahra_tipi_yangin_dolabi',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.5 mm Galvanized sheet.</li>
                                <li>Cover and reel mechanism can be fixed right or left without modification.</li>
                                <li>RAL 3002 Electrostatic powder coated .</li>
                                <li>Suitable for installation entry from right or left .</li>
                                <li>All with Galvanized sheet door.</li>
                                <li>Waterproof againist land conditions, with roof and stand.</li>
                                <li>Special lock system,disassambled doors.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>OUTDOOR TYPE FIRE HOSE CABINETS WITH SEMI RIGIT HOSE</figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_055_YD</td>
                                        <td>20 mt.</td>
                                        <td>750x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Terrain Type</td>
                                    </tr>
                                    <tr>
                                        <td>İY_056_YD</td>
                                        <td>25 mt.</td>
                                        <td>750x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Terrain Type</td>
                                    </tr>
                                    <tr>
                                        <td>İY_057_YD</td>
                                        <td>30 mt.</td>
                                        <td>750x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Terrain Type</td>
                                    </tr>

                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 11,
                    name: 'OUTDOOR TYPE FIRE HOSE CABINETS WITH LAY FLAT FIRE HOSE',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/bezli_sistem_sahra_tipi_yangin_dolabi/image-141.png',
                        process.env.PUBLIC_URL + '/images/products/bezli_sistem_sahra_tipi_yangin_dolabi/image-140.png',
                    ],
                    content: '',
                    link: '/product/0/11/bezli_sistem_sahra_tipi_yangin_dolabi',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Branch pipe  : <span>2" (or 2 1/2)"</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off).</li>
                                <li>TSE 3145 Certified.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>2" (DN50) or 2 1/2" ( DN 65)</span></figcaption>
                            <ul>
                                <li>TS EN 9222 certified .</li>
                                <li>17 bar working pressure .</li>
                                <li>50 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Coupling  : <span>2" or 2 1/2"</span></figcaption>
                            <ul>
                                <li>TS 12258 certified .</li>
                            </ul>
                        </figure>
                        {/* <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                                <li>2"-1" adaptörlü or 1” (DN 25) ball valve. </li>
                            </ul>
                        </figure> */}
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.5 mm Galvanized sheet.</li>
                                <li>Cover and reel mechanism can be fixed right or left without modification.</li>
                                <li>RAL 3002 Electrostatic powder coated .</li>
                                <li>Suitable for installation entry from right or left .</li>
                                <li>All with Galvanized sheet door.</li>
                                <li>Waterproof againist land conditions, with roof and stand.</li>
                                <li>Special lock system,disassambled doors.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>OUTDOOR TYPE FIRE HOSE CABINETS WITH LAY FLAT FIRE HOSE</figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_058_YD</td>
                                        <td>20 mt.</td>
                                        <td>750x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Terrain Type</td>
                                    </tr>
                                    <tr>
                                        <td>İY_059_YD</td>
                                        <td>25 mt.</td>
                                        <td>750x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Terrain Type</td>
                                    </tr>
                                    <tr>
                                        <td>İY_060_YD</td>
                                        <td>30 mt.</td>
                                        <td>750x750x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Terrain Type</td>
                                    </tr>

                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 12,
                    name: 'OUTDOOR TYPE FIRE HOSE CABINETS WITH DOUBLE LAY FLAT FIRE HOSE',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/cift_makarali_bezli_sistem_sahra_tipi_yangin_dolaplari/image-162.png',
                        process.env.PUBLIC_URL + '/images/products/cift_makarali_bezli_sistem_sahra_tipi_yangin_dolaplari/image-156.png',
                        process.env.PUBLIC_URL + '/images/products/cift_makarali_bezli_sistem_sahra_tipi_yangin_dolaplari/image-157.png',
                    ],
                    content: '',
                    link: '/product/0/12/cift_makarali_bezli_sistem_sahra_tipi_yangin_dolaplari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Branch pipe  : <span>2" (or 2 1/2)"</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off).</li>
                                <li>TSE 3145 Certified.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>2" (DN50) or 2 1/2" ( DN 65)</span></figcaption>
                            <ul>
                                <li>TS EN 9222 certified .</li>
                                <li>17 bar working pressure .</li>
                                <li>50 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Coupling  : <span>2" or 2 1/2"</span></figcaption>
                            <ul>
                                <li>TS 12258 certified .</li>
                            </ul>
                        </figure>
                        {/* <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                                <li>2"-1" adaptörlü or 1” (DN 25) ball valve. </li>
                            </ul>
                        </figure> */}
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.5 mm Galvanized sheet.</li>
                                <li>Cover and reel mechanism can be fixed right or left without modification.</li>
                                <li>RAL 3002 Electrostatic powder coated .</li>
                                <li>Suitable for installation entry from right or left .</li>
                                <li>All with Galvanized sheet door.</li>
                                <li>Waterproof againist land conditions, with roof and stand.</li>
                                <li>Special lock system,disassambled doors.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>OUTDOOR TYPE FIRE HOSE CABINETS WITH DOUBLE LAY FLAT FIRE HOSE</figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_061_YD</td>
                                        <td>20 mt.</td>
                                        <td>70x115x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Terrain Type</td>
                                    </tr>
                                    <tr>
                                        <td>İY_062_YD</td>
                                        <td>25 mt.</td>
                                        <td>70x115x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Terrain Type</td>
                                    </tr>
                                    <tr>
                                        <td>İY_063_YD</td>
                                        <td>30 mt.</td>
                                        <td>70x115x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Terrain Type</td>
                                    </tr>

                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 13,
                    name: 'FIRE HOSE CABINETS WITH FOAM ',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/köpüklü_yangin_dolabi/image-155.png',
                        process.env.PUBLIC_URL + '/images/products/köpüklü_yangin_dolabi/image-154.png',
                    ],
                    content: '',
                    link: '/product/0/13/köpüklü_yangin_dolabi',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)"</span></figcaption>
                            <ul>
                                <li>special foam nozzle.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>1” (DN 25) ball valve.</li>
                            </ul>
                        </figure>
                        {/* <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                                <li>2"-1" adaptörlü or 1” (DN 25) ball valve. </li>
                            </ul>
                        </figure> */}
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Proportioner </figcaption>
                            <ul>
                                <li>1” (DN 25) adjustable proportioner.</li>
                            </ul>
                        </figure>
                        {/* <figure>
                            <figcaption>Tank</figcaption>
                            <ul>
                                <li>40 lt kapasiteli özel fiber malzemeden üretilmiştir.</li>
                            </ul>
                        </figure> */}
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.5 mm Galvanized sheet.</li>
                                <li>Cover and reel mechanism can be fixed right or left without modification.</li>
                                <li>RAL 3002 Electrostatic powder coated .</li>
                                <li>Suitable for installation entry from right or left .</li>
                                <li>All with Galvanized sheet door.</li>
                                <li>Waterproof againist land conditions, with roof and stand.</li>
                                <li>Special lock system,disassambled doors.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>FIRE HOSE CABINETS WITH FOAM </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Hose</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_064_YD</td>
                                        <td>20 mt.</td>
                                        <td>750x1150x300 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Sparkling</td>
                                    </tr>
                                    <tr>
                                        <td>İY_065_YD</td>
                                        <td>25 mt.</td>
                                        <td>750x1150x300 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Sparkling</td>
                                    </tr>
                                    <tr>
                                        <td>İY_066_YD</td>
                                        <td>30 mt.</td>
                                        <td>750x1150x300 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Sparkling</td>
                                    </tr>

                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 14,
                    name: 'FIRE HOSE TROLLEYS',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/sulu_sistem_hortum_arabalari/image-172.png',
                        process.env.PUBLIC_URL + '/images/products/sulu_sistem_hortum_arabalari/image-173.png',
                    ],
                    content: '',
                    link: '/product/0/14/sulu_sistem_hortum_arabalari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)"</span></figcaption>
                            <ul>
                                <li>10mm orifice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        {/* <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                                <li>2"-1" adaptörlü or 1” (DN 25) ball valve. </li>
                            </ul>
                        </figure> */}
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>RAL 3002 Electrostatic powder coated .</li>
                                <li>Crank system to simplify rewinding.</li>
                                <li>Roller hub made of brass material. </li>
                                <li>Optional 40-50-60 mt. Production .</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 15,
                    name: 'FIRE HOSE REELS ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/saft_içi_sulu_sistem_yangin_makarasi/image-169.png'],
                    content: '',
                    link: '/product/0/15/saft_içi_sulu_sistem_yangin_makarasi',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Nozzle  : <span>1" (Ø 25mm)"</span></figcaption>
                            <ul>
                                <li>10mm orfice</li>
                                <li>3 position ( jet,spray,shut –off)</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Hose : <span>1" (Ø 25mm)</span></figcaption>
                            <ul>
                                <li>TS EN 694 certified semi –rigit hose.</li>
                                <li>12 bar working pressure .</li>
                                <li>36 bar explosion pressure .</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                            </ul>
                        </figure>
                        {/* <figure>
                            <figcaption>Valve</figcaption>
                            <ul>
                                <li>Optional 2” (DN 50 ) or 1” (DN 25) valve.</li>
                                <li>2"-1" adaptörlü or 1” (DN 25) ball valve. </li>
                            </ul>
                        </figure> */}
                        <figure>
                            <figcaption>Reel</figcaption>
                            <ul>
                                <li>Made of special profile sheet steel .</li>
                                <li>Electrostatic powder coated .</li>
                                <li>Optional 20-25-30 mt. Production .</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 16,
                    name: 'FIRE EQUIPMENT CABINETS ',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/koruyucu_malzeme_dolabi/image-178.png',
                        process.env.PUBLIC_URL + '/images/products/koruyucu_malzeme_dolabi/image-175.png',
                        process.env.PUBLIC_URL + '/images/products/koruyucu_malzeme_dolabi/image-176.png',
                        process.env.PUBLIC_URL + '/images/products/koruyucu_malzeme_dolabi/image-177.png',
                    ],
                    content: '',
                    link: '/product/0/16/köpüklü_yangin_dolabi',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Cabinet  </figcaption>
                            <ul>
                                <li>Made of 1.5 mm Galvanized sheet.</li>
                                <li>RAL 3002 Electrostatic powder coated .</li>
                                <li>Door can be fixed right or left without modification.</li>
                                <li>Complete sheet or 4 mm tempered glass door.</li>
                                <li>With adjustable shelf.</li>
                                <li>With foot or stand.</li>
                                <li>Special lock system,disassambled doors.</li>
                                <li>Can be produced in requested sizes.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>FIRE EQUIPMENT CABINETS </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_067_YD</td>
                                        <td>700x1500x500 mm</td>
                                        <td>Sheet Iron</td>
                                    </tr>
                                    <tr>
                                        <td>İY_068_YD</td>
                                        <td>700x1500x500 mm</td>
                                        <td>Glazed</td>
                                    </tr>


                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 17,
                    name: 'FIRE EXTINGUISHER CABINETS',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/yangin_sondurme_cihazi_dolaplari/image-174.png',
                        process.env.PUBLIC_URL + '/images/products/yangin_sondurme_cihazi_dolaplari/image-185.png',
                        process.env.PUBLIC_URL + '/images/products/yangin_sondurme_cihazi_dolaplari/image-186.png',
                        process.env.PUBLIC_URL + '/images/products/yangin_sondurme_cihazi_dolaplari/image-187.png',
                    ],
                    content: '',
                    link: '/product/0/17/yangin_sondurme_cihazi_dolaplari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>

                        <figure>
                            <figcaption>FIRE EXTINGUISHER CABINETS </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Dimensions</th>
                                        <th>Door</th>
                                        <th>Model</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_069_YD</td>
                                        <td>210x710x210 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_070_YD</td>
                                        <td>210x710x210 mm</td>
                                        <td>Glazed</td>
                                        <td>Recessed</td>
                                    </tr>
                                    <tr>
                                        <td>İY_071_YD</td>
                                        <td>300x730x240 mm</td>
                                        <td>Sheet Iron</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                    <tr>
                                        <td>İY_072_YD</td>
                                        <td>300x730x240 mm</td>
                                        <td>Glazed</td>
                                        <td>Surface Mounted</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
            ]
        }
    },
    {
        category: {
            id: 3,
            name: 'FIRE DOORS',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/tek_kanat_yangin_kapilari/image-199.png'],
            content: 'EN 16034 and ISO certified fire doors in various models and features.',
            link: '/category/yanginhortumlari/3/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'SINGLE LEAF FIRE DOORS ',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/tek_kanat_yangin_kapilari/2.jpg',
                        process.env.PUBLIC_URL + '/images/products/tek_kanat_yangin_kapilari/image-199.png',
                        process.env.PUBLIC_URL + '/images/products/tek_kanat_yangin_kapilari/image-197.png',
                        process.env.PUBLIC_URL + '/images/products/tek_kanat_yangin_kapilari/image-200.png',
                    ],
                    content: '',
                    link: '/product/3/0/tek_kanat_yangin_kapilari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications  </figcaption>
                            <ul>
                                <li>Our fire doors have TSE EN 16034 standard and are produced with the following features.</li>
                                <li>FRAME : According to the project specification, it is produced from DKP or Galvanized sheet in 1,2 -1.5 mm thickness, as an adjustable full frame or half frame.</li>
                                <li>LEAF: It is produced single leaf from DKP or Galvanized sheet in 1-1.2 mm thickness according to the project specification.</li>
                                <li>GASKET: Intumescent (which expands by 170 °C and closes the gaps) and sound gasket are used.</li>
                                <li>PAINT: It is painted with electrostatic powder oven paint in the desired color based on the project specification.</li>
                                <li>HINGE: Since 1 spring hinge and 1 springless hinge are used, the doors close automatically.</li>
                                <li>ACCESSORIES: According to the project specification , superficial and recessed system panic bar, locked or unlocked outer handle, hydraulic door closer, door sorting mechanism, magnetic door holder, automatic guillotine under the door are used.</li>
                            </ul>
                        </figure>
                    </div>
                },
                {
                    id: 1,
                    name: 'DOUBLE LEAF FIRE DOORS ',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/cift_kanat_yangin_kapilari/image-201.png',
                        process.env.PUBLIC_URL + '/images/products/cift_kanat_yangin_kapilari/image-202.png',
                        process.env.PUBLIC_URL + '/images/products/cift_kanat_yangin_kapilari/image-203.png',
                    ],
                    content: '',
                    link: '/product/3/1/cift_kanat_yangin_kapilari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications  </figcaption>
                            <p>Our fire doors have TSE EN 16034 standard and are produced with the following features.</p>
                            <ul>
                                <li>FRAME : According to the project specification, it is produced from DKP or Galvanized sheet in 1,2 -1.5 mm thickness, as an adjustable full frame or half frame.</li>
                                <li>LEAF: It is produced double leaf from DKP or Galvanized sheet in 1-1.2 mm thickness according to the project specification.</li>
                                <li>GASKET: Intumescent (which expands by 170 °C and closes the gaps) and sound gasket are used.</li>
                                <li>PAINT: It is painted with electrostatic powder oven paint in the desired color based on the project specification.</li>
                                <li>HINGE: Since 1 spring hinge and 1 springless hinge are used, the doors close automatically.</li>
                                <li>ACCESSORIES: According to the project specification , superficial and recessed system panic bar, locked or unlocked outer handle, hydraulic door closer, door sorting mechanism, magnetic door holder, automatic guillotine under the door are used.</li>
                            </ul>
                        </figure>
                    </div>
                },
                {
                    id: 2,
                    name: 'GLAZED FIRE DOORS ',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/camli_yangin_kapilari/image-208.png',
                        process.env.PUBLIC_URL + '/images/products/camli_yangin_kapilari/image-207.png',
                        // process.env.PUBLIC_URL + '/images/products/camli_yangin_kapilari/image-206.png',
                        // process.env.PUBLIC_URL + '/images/products/camli_yangin_kapilari/image-205.png',
                    ],
                    content: '',
                    link: '/product/3/2/camli_yangin_kapilari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications  </figcaption>
                            <p>Our fire doors have TSE EN 16034 standard and are produced with the following features.</p>
                            <ul>
                                <li>FRAME : According to the project specification, it is produced from DKP or Galvanized sheet in 1,2 -1.5 mm thickness, as an adjustable full frame or half frame.</li>
                                <li>LEAF: It is produced single leaf from DKP or Galvanized sheet in 1-1.2 mm thickness according to the project specification.</li>
                                <li>GLASS: Glasses that are within EI120 class, avoid for the passage of flames, fume, toxic gases, radiant heat, and temperature completely for a period of 120 minutes.</li>
                                <li>GASKET: Intumescent (which expands by 170 °C and closes the gaps) and sound gasket are used.</li>
                                <li>PAINT: It is painted with electrostatic powder oven paint in the desired color based on the project specification.</li>
                                <li>HINGE: Since 1 spring hinge and 1 springless hinge are used, the doors close automatically.</li>
                                <li>ACCESSORIES: According to the project specification , superficial and recessed system panic bar, locked or unlocked outer handle, hydraulic door closer, door sorting mechanism, magnetic door holder, automatic guillotine under the door are used.</li>
                            </ul>
                        </figure>
                    </div>
                },
            ]
        }
    },
    {
        category: {
            id: 1,
            name: 'FIRE HOSES AND COUPLINGS ',
            imgsrc: [process.env.PUBLIC_URL + '/images/category/hortum.jpg'],
            content: 'TS 9222 certified fire hoses in accordance with ISO 9001:2014 quality management standards.',
            link: '/category/yanginhortumlari/1/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'SEMI RIGIT FIRE HOSES ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_hortumlari_rekorlari/image-193.png'],
                    content: '',
                    link: '/product/1/0/yari_sert_kaucuk_yangin_hortumlari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Specifications</figcaption>
                            <ul>
                                <li>Made of semi-hard rubber material comply with EN 694 .</li>
                                <li>No drying is required after use.</li>
                                <li>It is suitable for use in water system fire cabinets and mobile reels.</li>
                                <li>Sizes produced: from ¾” to 1″ in desired length.</li>
                                <li>Working pressure : 12 Bar</li>
                                <li>Test pressure: 18 Bar</li>
                                <li>Explosion pressure : 36 Bar</li>
                            </ul>
                        </figure>
                    </div>
                },
                {
                    id: 6,
                    name: 'LAY FLAT FIRE HOSE ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/category/hortum.jpg'],
                    content: '',
                    link: '/product/1/6/yari_sert_kaucuk_yangin_hortumlari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Specifications </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Inner Diameter   (Mm - İnç)</th>
                                        <th>Explosion pressure (Bar - Psi)</th>
                                        <th>Working pressure  (Bar - Psi)</th>
                                        <th>Weight +/-%5 (g/m)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_001_YH</td>
                                        <td>25 - 1"</td>
                                        <td>60 - 840</td>
                                        <td>20 - 280</td>
                                        <td>130</td>
                                    </tr>
                                    <tr>
                                        <td>İY_002_YH</td>
                                        <td>38 - 1 <sup>1/2″</sup></td>
                                        <td>50 - 700</td>
                                        <td>17 - 240</td>
                                        <td>195</td>
                                    </tr>
                                    <tr>
                                        <td>İY_003_YH</td>
                                        <td>45 - 1 <sup>3/4″</sup></td>
                                        <td>50 - 700</td>
                                        <td>17 - 240</td>
                                        <td>230</td>
                                    </tr>
                                    <tr>
                                        <td>İY_004_YH</td>
                                        <td>52 - 2"</td>
                                        <td>50 - 700</td>
                                        <td>17 - 240</td>
                                        <td>250</td>
                                    </tr>
                                    <tr>
                                        <td>İY_005_YH</td>
                                        <td>65 - 2 <sup>1/2″</sup></td>
                                        <td>50 - 700</td>
                                        <td>17 - 240</td>
                                        <td>365</td>
                                    </tr>
                                    <tr>
                                        <td>İY_006_YH</td>
                                        <td>70 - 2 <sup>3/4″</sup></td>
                                        <td>50 - 700</td>
                                        <td>17 - 240</td>
                                        <td>395</td>
                                    </tr>
                                    <tr>
                                        <td>İY_007_YH</td>
                                        <td>70 - 2 <sup>3/4″</sup></td>
                                        <td>50 - 700</td>
                                        <td>17 - 240</td>
                                        <td>395</td>
                                    </tr>
                                    <tr>
                                        <td>İY_008_YH</td>
                                        <td>75 -3"</td>
                                        <td>37 - 550</td>
                                        <td>13 - 180</td>
                                        <td>405</td>
                                    </tr>
                                    <tr>
                                        <td>İY_009_YH</td>
                                        <td>102 - 4"</td>
                                        <td>30 - 425</td>
                                        <td>10 - 140</td>
                                        <td>560</td>
                                    </tr>
                                    <tr>
                                        <td>İY_010_YH</td>
                                        <td>125 - 5"</td>
                                        <td>20</td>
                                        <td>7 - 110</td>
                                        <td>750</td>
                                    </tr>
                                    <tr>
                                        <td>İY_011_YH</td>
                                        <td>150 - 6"</td>
                                        <td>20 - 285</td>
                                        <td>7 - 110</td>
                                        <td>900</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 1,
                    name: 'HOSE COUPLINGS ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_hortumlari_rekorlari/1.jpg'],
                    content: '',
                    link: '/product/1/1/yangin_hortumlari_rekorlari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Specifications</figcaption>
                            <ul>
                                <li>Etial 160</li>
                                <li>Pressure injection </li>
                                <li>Open –close</li>
                                <li>Torque 3-5 Nm</li>
                                <li>Pressure Coupling Operation</li>
                                <li>Working pressure : 12 Bar</li>
                                <li>Test pressure: 24 Bar</li>
                                <li>TS 12258</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Technical Specification </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Claw </th>
                                        <th>Product Code</th>
                                        <th>Type</th>
                                        <th>B1</th>
                                        <th>B2</th>
                                        <th>L</th>
                                        <th>D1</th>
                                        <th>Weight</th>
                                        <th>Package Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>HR-25</td>
                                        <td>GNF 5000</td>
                                        <td>1" Hose Coupling u</td>
                                        <td>18 mm</td>
                                        <td>25 mm</td>
                                        <td>53 mm</td>
                                        <td>31 mm</td>
                                        <td>0,095</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>HR-25</td>
                                        <td>GNF 5010</td>
                                        <td>3/4" Hose Coupling u</td>
                                        <td>14 mm</td>
                                        <td>20 mm</td>
                                        <td>53 mm</td>
                                        <td>31 mm</td>
                                        <td>0,095</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>HR-38</td>
                                        <td>GNF 5020</td>
                                        <td>1 <sup>1/2″</sup> Hose Coupling u</td>
                                        <td>28 mm</td>
                                        <td>38 mm</td>
                                        <td>90 mm</td>
                                        <td>51 mm</td>
                                        <td>0,235</td>
                                        <td>42</td>
                                    </tr>
                                    <tr>
                                        <td>HR-C52</td>
                                        <td>GNF 5030</td>
                                        <td>2″ Hose Coupling u</td>
                                        <td>18 mm</td>
                                        <td>28 mm</td>
                                        <td>80 mm</td>
                                        <td>66 mm</td>
                                        <td>0,375</td>
                                        <td>36</td>
                                    </tr>
                                    <tr>
                                        <td>HR-C52</td>
                                        <td>GNF 5040</td>
                                        <td>2″ Hose Coupling u</td>
                                        <td>42 mm</td>
                                        <td>52 mm</td>
                                        <td>90 mm</td>
                                        <td>66 mm</td>
                                        <td>0,400</td>
                                        <td>36</td>
                                    </tr>
                                    <tr>
                                        <td>HR-B75</td>
                                        <td>GNF 5050-65</td>
                                        <td>2 <sup>1/2″</sup> Hose Coupling u</td>
                                        <td>55 mm</td>
                                        <td>65 mm</td>
                                        <td>125 mm</td>
                                        <td>89 mm</td>
                                        <td>0,765</td>
                                        <td>30</td>
                                    </tr>
                                    <tr>
                                        <td>HR-B75</td>
                                        <td>GNF 5050-70</td>
                                        <td>2 <sup>3/4″</sup> Hose Coupling u</td>
                                        <td>60 mm</td>
                                        <td>70 mm</td>
                                        <td>125 mm</td>
                                        <td>89 mm</td>
                                        <td>0,765</td>
                                        <td>30</td>
                                    </tr>
                                    <tr>
                                        <td>HR-B75</td>
                                        <td>GNF 5060</td>
                                        <td>3″ Hose Coupling u</td>
                                        <td>65 mm</td>
                                        <td>75 mm</td>
                                        <td>125 mm</td>
                                        <td>89 mm</td>
                                        <td>0,790</td>
                                        <td>30</td>
                                    </tr>
                                    <tr>
                                        <td>HR-A110</td>
                                        <td>GNF 5070</td>
                                        <td>4″ Hose Coupling u</td>
                                        <td>90 mm</td>
                                        <td>101 mm</td>
                                        <td>170 mm</td>
                                        <td>133 mm</td>
                                        <td>1,505</td>
                                        <td>12</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 2,
                    name: 'HOSE COUPLING  WRENCHES ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_hortumlari_rekorlari/unnamed.jpg'],
                    content: '',
                    link: '/product/1/2/yangin_hortumlari_rekor_anahtarlari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Specifications</figcaption>
                            <ul>
                                <li>Laser Cutting from 8 mm Sheet Metal.</li>
                                <li>Galvanized </li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Technical Specifications</figcaption>
                            <table>
                                <thead>
                                    <tr>

                                        <th>Product Code</th>
                                        <th>Type</th>
                                        <th>W</th>
                                        <th>Weight</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>GNF 8500</td>
                                        <td>2″-2 <sup>1/2″</sup> Hydrant wrench</td>
                                        <td>69 mm</td>
                                        <td>0,795</td>
                                    </tr>
                                    <tr>
                                        <td>GNF 8510</td>
                                        <td>2″-2 <sup>1/2″</sup> Coupling  wrench</td>
                                        <td></td>
                                        <td>0,430</td>
                                    </tr>
                                    <tr>
                                        <td>GNF 8520</td>
                                        <td>2 <sup>1/2″</sup>-4″ Coupling  wrench</td>
                                        <td></td>
                                        <td>0,645</td>
                                    </tr>
                                    <tr>
                                        <td>GNF 8501</td>
                                        <td>Multi-Purpose Hydrant wrench</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
            ]
        }
    },
    {
        category: {
            id: 2,
            name: 'BRANCH PIPES ',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/lanslar/Perdeleme-Lans-705x564.jpg'],
            content: 'Branch pipes with TS 3145 certificate in accordance with ISO 9001:2014 quality management standards.',
            link: '/category/lanslar/2/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'FULL JET BRANCHPIPES',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/lanslar/media582324ca3846a.png'],
                    content: '',
                    link: '/product/2/0/duz_lanslar',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications</figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Claw </th>
                                        <th>Type</th>
                                        <th>Weight</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>GNF7015</td>
                                        <td>İDR-38</td>
                                        <td>1<sup>1/2"</sup> Full jet PVC  branchpipe </td>
                                        <td>0,395</td>
                                    </tr>
                                    <tr>
                                        <td>GNF7020</td>
                                        <td>İDR-52</td>
                                        <td>2" Full jet PVC  branchpipe </td>
                                        <td>0,480</td>
                                    </tr>
                                    <tr>
                                        <td>GNF7005</td>
                                        <td>İDR-38</td>
                                        <td>1<sup>1/2"</sup> Full jet alum. branchpipe </td>
                                        <td>0,750</td>
                                    </tr>
                                    <tr>
                                        <td>GNF7000</td>
                                        <td>İDR-52</td>
                                        <td>2" Full jet alum. branchpipe </td>
                                        <td>0,840</td>
                                    </tr>
                                    <tr>
                                        <td>GNF7010</td>
                                        <td>İDR-65</td>
                                        <td>2 <sup>1/2"</sup> Full jet alum. branchpipe </td>
                                        <td>1,250</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 1,
                    name: 'BRANCHPIPE WITH SHUT-OFF  ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/lanslar/kumandali-lans-e134.jpeg'],
                    content: '',
                    link: '/product/2/1/kumandali_lanslar',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Specifications</figcaption>
                            <ul>
                                <li>Etial 160 .</li>
                                <li>TSE 3145 certified.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Technical Data </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Claw </th>
                                        <th>Type</th>
                                        <th>Weight</th>
                                        <th>Number of parcels</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>GNF7105</td>
                                        <td>İDR-38</td>
                                        <td>1<sup>1/2"</sup> Shut-off  branchpipe</td>
                                        <td>1,370</td>
                                        <td>25</td>
                                    </tr>
                                    <tr>
                                        <td>GNF7100</td>
                                        <td>İDR-52</td>
                                        <td>2" Shut-off  branchpipe</td>
                                        <td>1,475</td>
                                        <td>30</td>
                                    </tr>
                                    <tr>
                                        <td>GNF7110</td>
                                        <td>İDR-65</td>
                                        <td>2<sup>1/2"</sup> Shut-off  branchpipe</td>
                                        <td>1,860</td>
                                        <td>13</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 2,
                    name: 'BRANCHPIPE WITH SHUT-OFF  WATER CURTAIN SYSTEM ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/lanslar/Perdeleme-Lans-705x564.jpg'],
                    content: '',
                    link: '/product/2/2/perdeli_lanslar',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Specifications</figcaption>
                            <ul>
                                <li>Etial 160.</li>
                                <li>TSE 3145 certified.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TEKNİK VERİLER </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Claw </th>
                                        <th>Type</th>
                                        <th>Weight</th>
                                        <th>Number of parcels</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>GNF7145</td>
                                        <td>İDR-38</td>
                                        <td>1<sup>1/2"</sup> Shut-off  branchpipe</td>
                                        <td>1,750</td>
                                        <td>25</td>
                                    </tr>
                                    <tr>
                                        <td>GNF7150</td>
                                        <td>İDR-52</td>
                                        <td>2" Shut-off  branchpipe</td>
                                        <td>1,870</td>
                                        <td>30</td>
                                    </tr>
                                    <tr>
                                        <td>GNF7155</td>
                                        <td>İDR-65</td>
                                        <td>2<sup>1/2"</sup> Shut-off  branchpipe</td>
                                        <td>2,160</td>
                                        <td>13</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
            ]
        }
    },

    {
        category: {
            id: 15,
            name: 'EMERGENCY EXIT DOOR ACCESSORIES',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_cikis_aksesuarlari/image-209.png'],
            content: '',
            link: '/category/acil_cikis_aksesuarlari/15/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: '55M BACK MODULE',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_cikis_aksesuarlari/omnipanikbar.jpg'],
                    content: '',
                    link: '/product/15/0/acil_cikis_aksesuarlari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications  </figcaption>
                            <ul>
                                <li>Used for opening and locking from outside with 550 D
                                    Non-handed.</li>
                                <li>Aluminium alloy body and handle, corrosion-resistant steel and aluminium alloy aperating parts.</li>
                            </ul>
                        </figure>
                    </div>
                },
                {
                    id: 1,
                    name: 'ELECTROMAGNETIC LOCK',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_cikis_aksesuarlari/image-211.png'],
                    content: '',
                    link: '/product/15/1/acil_cikis_aksesuarlari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications  </figcaption>
                            <ul>
                                <li>Used for having electronic security by applying surface on the doors</li>
                                <li> 250 and 500 kg holding power.</li>
                                <li>Failsafe type (power to lock). </li>
                                <li>
                                    Power supply; 12 or 24V DC (optional)
                                </li>
                            </ul>
                        </figure>
                    </div>
                },
                {
                    id: 2,
                    name: 'SPRING HINGE',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_cikis_aksesuarlari/image-212.png'],
                    content: '',
                    link: '/product/15/2/acil_cikis_aksesuarlari',
                    detail: <div className="detail">
                        {/* <h2>Technical Specifications</h2> */}
                        <figure>
                            <figcaption>Technical Specifications  </figcaption>
                            <ul>
                                <li>Provides automatically closing of the door.</li>
                                <li>
                                    The set consists of spring loaded and non-spring hinges
                                </li>
                                <li>Closing speed is adjustable</li>
                                <li>Corrosion-resistant steel</li>
                            </ul>
                        </figure>
                    </div>
                },
                {
                    id: 3,
                    name: 'PANIC EXIT DEVICE',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_cikis_aksesuarlari/image-213.png'],
                    content: '',
                    link: '/product/15/3/acil_cikis_aksesuarlari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications  </figcaption>
                            <ul>
                                <li>Panic exit for mortise locking (660 GK) system
                                    Non-handed.</li>
                                <li>
                                    Has an adapter for applying back module (66 M)
                                </li>
                                <li>
                                    Corrosion-resistant steel body, aluminium alloy bracket,bolt and bar, operating parts are made of brass
                                </li>
                            </ul>
                        </figure>
                    </div>
                },
                {
                    id: 4,
                    name: 'PUSH BAR',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_cikis_aksesuarlari/image-214.png'],
                    content: '',
                    link: '/product/15/4/acil_cikis_aksesuarlari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications  </figcaption>
                            <ul>
                                <li>Used for fire exit doors. Since it is a cylinder from the outside, it can be locked and when it is locked, it can be opened when pressed from the inside.</li>
                                <li>
                                    There is no chance of opening with an arm from the outside. If you want to open with the arm, it is necessary to buy the Panic Bar Handle.</li>
                            </ul>
                        </figure>
                    </div>
                },
                {
                    id: 5,
                    name: 'UNDER DOOR GUILLOTINE',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_cikis_aksesuarlari/image-215.png'],
                    content: '',
                    link: '/product/15/5/acil_cikis_aksesuarlari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications  </figcaption>
                            <ul>
                                <li>When the door is closed, it automatically closes the gap under the door and prevents the passage of smoke, soot and sound.</li>
                                <li>
                                    It is applied to fire doors, emergency exit doors, metal doors and wooden doors.</li>
                                <li>It can be applied as recessed or on the door. It consists of aluminum profile and silicone wick.</li>
                            </ul>
                        </figure>
                    </div>
                },
                {
                    id: 6,
                    name: 'PANIC BAR SYSTEMS (Single Point Locking)',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_cikis_aksesuarlari/image-216.png'],
                    content: '',
                    link: '/product/15/6/acil_cikis_aksesuarlari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications  </figcaption>
                            <ul>
                                <li>The mechanism can be applied to both right and left opening doors. It complies with DIN 4102 norm.</li>
                                <li>
                                    Steel sheet body, housing, arms and bar are made of aluminum alloy, working parts are made of zamak alloy.</li>
                                <li>It has an adapter for arm applications used to manipulate from the outside.</li>
                            </ul>
                        </figure>
                    </div>
                },
            ]
        }
    },
    {
        category: {
            id: 4,
            name: 'FIRE RESISTANT SHAFT DOORS ',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/yangina_dayanikli_saft_kapaklari/image-217.png'],
            content: 'Fire resistant shaft doors in various models and features in accordance with EN 16034 Standard.',
            link: '/category/yangina_dayanikli_saft_kapaklari/4/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'FIRE RESISTANT SHAFT DOORS',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/yangina_dayanikli_saft_kapaklari/image-217.png',
                        process.env.PUBLIC_URL + '/images/products/yangina_dayanikli_saft_kapaklari/image-218.png',
                    ],
                    content: 'The technical details of our shaft doors , which are produced with a fire resistance of 60-90-120 minutes, are determined according to the projects.',
                    link: '/product/4/0/yangina_dayanikli_saft_kapaklari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Specifications </figcaption>
                            <ul>
                                <li>FRAME : According to the project specification, it is produced from DKP or Galvanized sheet in 1,2  mm thickness, as an adjustable full frame or half frame.</li>
                                <li>LEAF: It is produced single leaf from DKP or Galvanized sheet in 1 mm thickness according to the project specification.</li>
                                <li>GASKET: Intumescent (which expands by 170 °C and closes the gaps) and sound gasket are used.</li>
                                <li>PAINT: It is painted with electrostatic powder oven paint in the desired color based on the project specification.</li>
                                <li>HINGE: Since 1 spring hinge and 1 springless hinge are used, the doors close automatically.</li>
                                <li>LOCK : Triangle lock .</li>
                            </ul>
                        </figure>
                    </div>
                },
                {
                    id: 1,
                    name: 'STANDART SHAFT DOORS ',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/yangina_dayanikli_saft_kapaklari/image-219.png',
                        process.env.PUBLIC_URL + '/images/products/yangina_dayanikli_saft_kapaklari/image-220.png',
                    ],
                    content: '',
                    link: '/product/4/1/standart_saft_kapaklari',
                    detail: <div className="detail">
                        <h2>Technical Specifications</h2>
                        <figure>
                            <figcaption>Technical Specifications</figcaption>
                            <ul>
                                <li>FRAME : According to the project specification, it is produced from DKP or Galvanized sheet in 1,2  mm thickness, as an adjustable full frame or half frame.</li>
                                <li>LEAF: It is produced single leaf from DKP or Galvanized sheet in 1 mm thickness according to the project specification.</li>
                                <li>LOCK : Triangle lock.</li>
                                <li>PAINT: It is painted with electrostatic powder oven paint in the desired color based on the project specification.</li>
                                <li>HINGE: Special shaft hinge .</li>
                            </ul>
                        </figure>
                    </div>
                },
            ]
        }
    },
    {
        category: {
            id: 5,
            name: 'FIRE EXTINGUISHERS',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/kuru_kimyevi_tozlu_yangin_söndürme_cihazlari/image-225.png'],
            content: 'Dry Chemical Powder, Carbon Dioxide, Foam, Water portable fire extinguishers.',
            link: '/category/kuru_kimyevi_tozlu_yangin_söndürme_cihazlari/5/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'DRY CHEMICAL  POWDER FIRE  EXTINGUISHERS',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/kuru_kimyevi_tozlu_yangin_söndürme_cihazlari/image-225.png',
                        process.env.PUBLIC_URL + '/images/products/kuru_kimyevi_tozlu_yangin_söndürme_cihazlari/image-221.png',
                        process.env.PUBLIC_URL + '/images/products/kuru_kimyevi_tozlu_yangin_söndürme_cihazlari/image-222.png',
                    ],
                    content: '',
                    link: '/product/5/0/kuru_kimyevi_tozlu_yangin_söndürme_cihazlari',
                    detail: <div className="detail">
                        <h2></h2>
                        <figure>
                            <h2>USAGE AREAS </h2>
                            <figcaption>CLASS A FIRE</figcaption>
                            <ul>
                                <li>Wood materials, Herbs bush-whistle, Papers, Garments, All Fabrics, Curtains-home textiles, Office-home furniture Rubber cellulose, Plastics.</li>
                            </ul>
                            <figcaption>CLASS B FIRE</figcaption>
                            <ul>
                                <li>Gasoline, Benzol, Diesel, Varnish, Paints, Thinner, Acetone, Paraffin, Asphalt, Glue, Cooking Oils, Industrial Oils.</li>
                            </ul>
                            <figcaption>CLASS C FIRE</figcaption>
                            <ul>
                                <li>Natural Gas, LPG, Methane, Hydrogen, Propane, Acetylene, Electric cables, Electric trophies, Power sources IT units, Electronic household goods, Electrical household goods.
                                </li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Technical Data </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Powder weight (kg) </th>
                                        <th>Gross weight (kg)</th>
                                        <th>Foam </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_001_YSC</td>
                                        <td>1 kg</td>
                                        <td>2,25 kg</td>
                                        <td>ABC Dry chemical powder % 40 MAP</td>
                                    </tr>
                                    <tr>
                                        <td>İY_002_YSC</td>
                                        <td>2 kg</td>
                                        <td>3,70 kg</td>
                                        <td>ABC Dry chemical powder % 40 MAP</td>
                                    </tr>
                                    <tr>
                                        <td>İY_003_YSC</td>
                                        <td>4 kg</td>
                                        <td>7,30 kg</td>
                                        <td>ABC Dry chemical powder % 40 MAP</td>
                                    </tr>
                                    <tr>
                                        <td>İY_004_YSC</td>
                                        <td>6 kg</td>
                                        <td>9,80 kg</td>
                                        <td>ABC Dry chemical powder % 40 MAP</td>
                                    </tr>
                                    <tr>
                                        <td>İY_005_YSC</td>
                                        <td>9 kg</td>
                                        <td>14,50 kg</td>
                                        <td>ABC Dry chemical powder % 40 MAP</td>
                                    </tr>
                                    <tr>
                                        <td>İY_006_YSC</td>
                                        <td>12 kg</td>
                                        <td>18,50 kg</td>
                                        <td>ABC Dry chemical powder % 40 MAP</td>
                                    </tr>
                                    <tr>
                                        <td>İY_007_YSC</td>
                                        <td>25 kg</td>
                                        <td>45 kg</td>
                                        <td>ABC Dry chemical powder % 40 MAP</td>
                                    </tr>
                                    <tr>
                                        <td>İY_008_YSC</td>
                                        <td>50 kg</td>
                                        <td>79 kg</td>
                                        <td>ABC Dry chemical powder % 40 MAP</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 1,
                    name: 'FOAM FIRE EXTINGUISHERS',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/kopuklu_yangin_söndürme_cihazlari/image-225.png',
                        process.env.PUBLIC_URL + '/images/products/kopuklu_yangin_söndürme_cihazlari/image-221.png',
                        process.env.PUBLIC_URL + '/images/products/kopuklu_yangin_söndürme_cihazlari/image-222.png',
                    ],
                    content: '',
                    link: '/product/5/1/kopuklu_yangin_söndürme_cihazlari',
                    detail: <div className="detail">
                        <h2>USAGE AREAS </h2>
                        <figure>
                            <figcaption>CLASS A FIRE</figcaption>
                            <ul>
                                <li>Wood materials, Herbs bush-whistle, Papers, Garments, All Fabrics, Curtains-home textiles, Office-home furniture Rubber cellulose, Plastics.</li>
                            </ul>
                            <figcaption>CLASS B FIRE</figcaption>
                            <ul>
                                <li>Gasoline, Benzol, Diesel, Varnish, Paints, Thinner, Acetone, Paraffin, Asphalt, Glue, Cooking Oils, Industrial Oils.</li>
                            </ul>
                            {/* <figcaption>CLASS C FIRE</figcaption>
                            <ul>
                                <li>Natural Gas, LPG, Methane, Hydrogen, Propane, Acetylene, Electric cables, Electric trophies, Power sources IT units, Electronic household goods, Electrical household goods.
                                </li>
                            </ul> */}
                        </figure>
                        <figure>
                            <figcaption>Technical Data </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Foam weight (kg) </th>
                                        <th>Gross weight (kg)</th>
                                        <th>Foam </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_009_YSC</td>
                                        <td>2 lt</td>
                                        <td>3,70 kg</td>
                                        <td>%6 AFFF Foam</td>
                                    </tr>
                                    <tr>
                                        <td>İY_0010_YSC</td>
                                        <td>3 lt</td>
                                        <td>5,55 kg</td>
                                        <td>%6 AFFF Foam</td>
                                    </tr>
                                    <tr>
                                        <td>İY_0011_YSC</td>
                                        <td>6 lt</td>
                                        <td>9,80 kg</td>
                                        <td>%6 AFFF Foam</td>
                                    </tr>
                                    <tr>
                                        <td>İY_0012_YSC</td>
                                        <td>9 lt</td>
                                        <td>14,50 kg</td>
                                        <td>%6 AFFF Foam</td>
                                    </tr>
                                    <tr>
                                        <td>İY_0013_YSC</td>
                                        <td>25 lt</td>
                                        <td>45 kg</td>
                                        <td>%6 AFFF Foam</td>
                                    </tr>
                                    <tr>
                                        <td>İY_0014_YSC</td>
                                        <td>50 lt</td>
                                        <td>79 kg</td>
                                        <td>%6 AFFF Foam</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 2,
                    name: 'CARBON DIOXIDE FIRE EXTINGUISHERS',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/karbondioksit(co2)_gazli_yangin_sondurme_cihazlari/image-226.png',
                        process.env.PUBLIC_URL + '/images/products/karbondioksit(co2)_gazli_yangin_sondurme_cihazlari/image-227.png',
                        process.env.PUBLIC_URL + '/images/products/karbondioksit(co2)_gazli_yangin_sondurme_cihazlari/image-229.png',
                    ],
                    content: '',
                    link: '/product/5/2/karbondioksit(co2)_gazli_yangin_sondurme_cihazlari',
                    detail: <div className="detail">
                        <h2>USAGE AREAS </h2>
                        <figure>
                            {/* <figcaption>CLASS A FIRE</figcaption>
                            <ul>
                                <li>Wood materials, Herbs bush-whistle, Papers, Garments, All Fabrics, Curtains-home textiles, Office-home furniture Rubber cellulose, Plastics.</li>
                            </ul>
                            <figcaption>CLASS B FIRE</figcaption>
                            <ul>
                                <li>Gasoline, Benzol, Diesel, Varnish, Paints, Thinner, Acetone, Paraffin, Asphalt, Glue, Cooking Oils, Industrial Oils.</li>
                            </ul> */}
                            <figcaption>CLASS C FIRE</figcaption>
                            <ul>
                                <li>Natural Gas, LPG, Methane, Hydrogen, Propane, Acetylene, Electric cables, Electric trophies, Power sources IT units, Electronic household goods, Electrical household goods.
                                </li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Technical Data </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>CO2 weight (kg) </th>
                                        <th>Gross weight (kg)</th>
                                        <th>Foam </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_015_YSC</td>
                                        <td>2 kg</td>
                                        <td>6,56 kg</td>
                                        <td>CO2</td>
                                    </tr>
                                    <tr>
                                        <td>İY_016_YSC</td>
                                        <td>5 kg</td>
                                        <td>17,15 kg</td>
                                        <td>CO2</td>
                                    </tr>
                                    <tr>
                                        <td>İY_017_YSC</td>
                                        <td>10 kg</td>
                                        <td>40,95 kg</td>
                                        <td>CO2</td>
                                    </tr>
                                    <tr>
                                        <td>İY_018_YSC</td>
                                        <td>30 kg</td>
                                        <td>95 kg</td>
                                        <td>CO2</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
                {
                    id: 3,
                    name: 'AUTOMATIC FIRE EXTINGUISHERS',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/kuru_kimyevi_tozlu_yangin_söndürme_cihazlari/image-223.png',
                    ],
                    content: '',
                    link: '/product/5/3/otomatik_yangin_sondurme_cihazlari',
                    detail: <div className="detail">
                        <h2>USAGE AREAS </h2>
                        <figure>
                            <figcaption>CLASS A FIRE</figcaption>
                            <ul>
                                <li>Wood materials, Herbs bush-whistle, Papers, Garments, All Fabrics, Curtains-home textiles, Office-home furniture Rubber cellulose, Plastics.</li>
                            </ul>
                            <figcaption>CLASS B FIRE</figcaption>
                            <ul>
                                <li>Gasoline, Benzol, Diesel, Varnish, Paints, Thinner, Acetone, Paraffin, Asphalt, Glue, Cooking Oils, Industrial Oils.</li>
                            </ul>
                            <figcaption>CLASS C FIRE</figcaption>
                            <ul>
                                <li>Natural Gas, LPG, Methane, Hydrogen, Propane, Acetylene, Electric cables, Electric trophies, Power sources IT units, Electronic household goods, Electrical household goods.
                                </li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Technical Data  </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Capacity</th>
                                        <th>Gross weight (kg)</th>
                                        <th>Foam </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_019_YSC</td>
                                        <td>6 kg</td>
                                        <td>9,4 kg</td>
                                        <td>ABC Dry chemical powder % 40 MAP</td>
                                    </tr>
                                    <tr>
                                        <td>İY_020_YSC</td>
                                        <td>12 kg</td>
                                        <td>13,8 kg</td>
                                        <td>ABC Dry chemical powder % 40 MAP</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
            ]
        }
    },
    {
        category: {
            id: 6,
            name: 'FIRE ALARM SYSTEMS',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-233.png'],
            content: 'Addressable and conventional fire alarm systems.',
            link: '/category/adresli_yangin_alarm_sistemleri/6/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'ADDRESSABLE FIRE ALARM SYSTEMS',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-230.png',
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-231.png',
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-232.png',
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/0210f707d.jfif',
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-234.png',
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-235.png',
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-236.png',
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/2b43a2a8d.jfif',
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-238.png',

                    ],
                    content: '',
                    link: '/product/6/0/adresli_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Specification</h2>

                        <figure>
                            {/* <figcaption>CLASS A FIRE</figcaption> */}
                            <p>
                                Today, as with all technological devices, our living spaces; public buildings, hotels, hospitals are getting smarter. Working with brands that have proven their quality globally, İNTEKS FIRE SECURITY manages to attract all attention with its high service quality. Our company, which offers addressable fire alarm systems with advanced devices, protects life and property safety in buildings. Each fire loop that comes out of the switchboard as a fire-resistant cable passes over elements such as detectors, call points, sounders and ends in the same switchboard. Detectors and call points included in the loop are used for fire alarm. Call points are designed for manual use, while detectors detect smoke and heat.
                            </p>
                            <p>Beam detector models are used as a transceiver pair in areas with high ceilings such as warehouses and hangars. Infrared rays emanating from the transmitter return to the transmitter from the reflective part called the receiver. The rays that cannot return in places where smoke is formed are the harbinger of fire. Duct detectors are preferred in air handling units and ventilation ducts. Seismic relay models that detect vibration during an earthquake can be included in fire loops, also known as loops. Sometimes, LPG detectors or natural gas detectors are preferred in the alarm system for places such as kitchens, dining halls, laboratories. The carbon monoxide detector, on the other hand, is used to detect intense exhaust gas in closed parking areas. All devices working in harmony with each other in the same cycle aim for full protection.


                            </p>
                            <h4>Pinpoint Location Detection with Smart Switchboards</h4>
                            <p>A numerical address is given to each alarm device in addressable fire alarm systems. This address is used as the unique identification number of the devices. After the installation is completed, the room or location of the devices whose information is entered into the fire station is also processed. In the event of a fire, the power plant instantly displays the information of the crime scene thanks to the signal coming from the detector or button. In this way, the operator can intervene more quickly and accurately where the notification is received. Addressable fire alarm system that prevents time losses; It is especially preferred in multi-room buildings such as student dormitories, public buildings, shopping malls, hospitals or hotels. Fire scenarios can also be applied in areas with high population capacity. In this context, automatic actions such as bringing the elevators to the designated floor and opening the doors, stopping the escalators, and lowering the fire curtains can be implemented in the vicinity of the notification. As İNTEKS FIRE SECURITY , we offer solutions with Bosch, Honeywell, Gloobal GFE, Eleks, teknim, Mavigard, Finder and world-renowned brands.
                            </p>
                            {/* <ul>
                                <li>Wood materials, Herbs bush-whistle, Papers, Garments, All Fabrics, Curtains-home textiles, Office-home furniture Rubber cellulose, Plastics.</li>
                            </ul>
                            <figcaption>CLASS B FIRE</figcaption>
                            <ul>
                                <li>Gasoline, Benzol, Diesel, Varnish, Paints, Thinner, Acetone, Paraffin, Asphalt, Glue, Cooking Oils, Industrial Oils.</li>
                            </ul>
                            <figcaption>CLASS C FIRE</figcaption>
                            <ul>
                                <li>Natural Gas, LPG, Methane, Hydrogen, Propane, Acetylene, Electric cables, Electric trophies, Power sources IT units, Electronic household goods, Electrical household goods.
                                </li>
                            </ul> */}
                        </figure>
                        <figure>
                            <figcaption>Equipment in the Fire Alarm System</figcaption>
                            <S.Items>
                                <S.InItem to="/product/6/2/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-231.png'} alt="" />
                                    <span>OPTICAL SMOKE DEDECTOR</span>
                                </S.InItem>
                                <S.InItem to="/product/6/3/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-232.png'} alt="" />
                                    <span>STANDARD DETECTOR SOCKET</span>
                                </S.InItem>
                                <S.InItem to="/product/6/4/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-233.png'} alt="" />
                                    <span>ADRESSABLE FIRE ALARM CALL POINT</span>
                                </S.InItem>
                                <S.InItem to="/product/6/5/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-234.png'} alt="" />
                                    <span>ADRESSABLE FIRE ALARM SOUNDER</span>
                                </S.InItem>
                                <S.InItem to="/product/6/6/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-235.png'} alt="" />
                                    <span>ADRESSABLE FIRE ALARM SOUNDER WITH FLASHER</span>
                                </S.InItem>
                                <S.InItem to="/product/6/0/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-236.png'} alt="" />
                                    <span>BATTERY </span>
                                </S.InItem>
                                <S.InItem to="/product/6/8/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-237.png'} alt="" />
                                    <span>LPG & NATURAL GAS DEDECTOR </span>
                                </S.InItem>
                                <S.InItem to="/product/6/0/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-238.png'} alt="" />
                                    <span>EARTHQUAKE SENSOR</span>
                                </S.InItem>
                            </S.Items>
                        </figure>
                    </div>
                },
                {
                    id: 1,
                    name: 'CONVENTIONAL FIRE ALARM SYSTEMS',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/konvansiyonel_yangin_alarm_sistemleri/image-239.png',
                        process.env.PUBLIC_URL + '/images/products/konvansiyonel_yangin_alarm_sistemleri/image-240.png',
                        process.env.PUBLIC_URL + '/images/products/konvansiyonel_yangin_alarm_sistemleri/image-241.png',
                        process.env.PUBLIC_URL + '/images/products/konvansiyonel_yangin_alarm_sistemleri/image-242.png',
                        process.env.PUBLIC_URL + '/images/products/konvansiyonel_yangin_alarm_sistemleri/image-243.png',
                        process.env.PUBLIC_URL + '/images/products/konvansiyonel_yangin_alarm_sistemleri/image-244.png',
                        process.env.PUBLIC_URL + '/images/products/konvansiyonel_yangin_alarm_sistemleri/image-245.png',
                        process.env.PUBLIC_URL + '/images/products/konvansiyonel_yangin_alarm_sistemleri/image-246.png',
                        process.env.PUBLIC_URL + '/images/products/konvansiyonel_yangin_alarm_sistemleri/image-247.png',
                    ],
                    content: '',
                    link: '/product/6/1/adresli_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Specification</h2>
                        <figure>
                            <p>Conventional Fire Alarm System is preferred especially in small and medium-sized businesses or living spaces and provides vital protection with its economical solutions. The system model, which prevents loss of life with the warning methods it gives in the event of a fire, also prevents valuables and documents from becoming ashes. The system, which detects the fire locally, saves time for evacuation and extinguishing. Automatic warning systems, which provide rapid evacuation of the scene in the event of a fire, also accelerate the start of rescue operations. Aiming to minimize material and moral losses, fire alarm systems are easily used in public areas.
                            </p>
                            <p>Zone, which means zone, forms the basis of conventional fire alarm systems logic. Special fire devices are connected in series to the fire resistant cable coming out of the switchboard. At the end of the line, a terminating resistor is usually installed. Cables and elements going from the fire station to the termination resistor form 1 zone. When a warning is received from any of the fire elements on the line belonging to the region, that region is signaled at the fire station. Thus, the fire is detected locally. Elements Used in Fire System In conventional fire warning systems, optical detector models that detect smoke are used. Apart from this, there are temperature detectors that detect high temperature or multi-detector types that can detect both heat and smoke. Heat, smoke or multi detectors can be used on the ceiling or in the attic depending on the project. Duct detectors monitor the ventilation ducts connected to the air handling unit. Beam detectors, also known as Beam, are preferred in high ceiling areas where normal detectors cannot work. Detectors that send infrared rays receive the reflected light from the opposite reflector again. Beam detector sends a warning signal to the switchboard when the smoke formed during the fire blocks the beam passing through the middle. Thus, possible fire hazards can be detected early in large warehouses such as factories and hangars. When the call point within the zone are pressed manually, it sends a notification to the switchboard. Carbon monoxide detectors, which are mostly used in indoor parking lots, are preferred for excessive exhaust gas. LPG detector or natural gas detector saves lives in kitchens where gas is used as fuel. After the notification process, the warning stage is started. The leading role for the alarm system is reserved for fire beacon and sounder models. These devices, which give an audible and/or light alarm, speed up the evacuation. As İNTEKS FIRE SECURITY, we offer solutions with Bosch, Honeywell, Gloobal GFE, Eleks, Teknim, Mavigard, Finder and world-renowned brands.
                            </p>
                        </figure>
                        <figure>
                            <figcaption>Equipment in the Fire Alarm System</figcaption>
                            <S.Items>
                                <S.InItem to="/product/6/2/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-231.png'} alt="" />
                                    <span>OPTICAL SMOKE DEDECTOR</span>
                                </S.InItem>
                                <S.InItem to="/product/6/3/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-232.png'} alt="" />
                                    <span>STANDARD DETECTOR SOCKET</span>
                                </S.InItem>
                                <S.InItem to="/product/6/4/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-233.png'} alt="" />
                                    <span>CONVENTIONAL FIRE ALARM CALL POINT</span>
                                </S.InItem>
                                <S.InItem to="/product/6/5/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-234.png'} alt="" />
                                    <span>CONVANTIONAL  FIRE ALARM SOUNDER</span>
                                </S.InItem>
                                <S.InItem to="/product/6/6/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-235.png'} alt="" />
                                    <span>CONVENTIONAL FIRE ALARM SOUNDER WITH FLASHER</span>
                                </S.InItem>
                                <S.InItem to="/product/6/0/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-236.png'} alt="" />
                                    <span>BATTERY </span>
                                </S.InItem>
                                <S.InItem to="/product/6/8/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-237.png'} alt="" />
                                    <span>LPG & NATURAL GAS DEDECTOR </span>
                                </S.InItem>
                                <S.InItem to="/product/6/0/adresli_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-238.png'} alt="" />
                                    <span>EARTHQUAKE SENSOR</span>
                                </S.InItem>
                            </S.Items>
                        </figure>
                    </div>
                },
                {
                    id: 51,
                    name: 'CARBONMONOXIDE DETECTION SYSTEMS',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/karbonmonoksit_yangin_alarm_sistemleri/1.jpg',
                        process.env.PUBLIC_URL + '/images/products/karbonmonoksit_yangin_alarm_sistemleri/2.jpg',
                    ],
                    content: '',
                    link: '/product/6/51/karbonmonoksit_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        {/* <h2>Technical Details</h2> */}

                        <figure>
                            <figcaption>Equipment in the Fire Alarm System</figcaption>
                            <S.Items>
                                <S.InItem to="/product/6/30/karbonmonoksit_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/karbonmonoksit_yangin_alarm_sistemleri/1.jpg'} alt="" />
                                    <span>CARBONMONOXIDE DEDECTOR</span>
                                </S.InItem>
                                <S.InItem to="/product/6/31/karbonmonoksit_yangin_alarm_sistemleri">
                                    <img src={process.env.PUBLIC_URL + '/images/products/karbonmonoksit_yangin_alarm_sistemleri/2.jpg'} alt="" />
                                    <span>CARBONMONOXIDE CONTROL PANEL </span>
                                </S.InItem>

                            </S.Items>
                        </figure>
                    </div>
                },
                {
                    id: 30,
                    name: 'CARBONMONOXIDE DEDECTOR',
                    hide: true,
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/karbonmonoksit_yangin_alarm_sistemleri/1.jpg',
                        // process.env.PUBLIC_URL + '/images/products/karbonmonoksit_yangin_alarm_sistemleri/2.jpg',
                    ],
                    content: '',
                    link: '/product/6/30/karbonmonoksit_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Data </h2>
                        <figure>
                            <p>The KMD300 detector is designed as a carbon monoxide detector for the KM300 Series CO detection systems. The KMD300 is a smart device that delivers carbon monoxide gas to the control panel for visualization via a 3-wire bus system. </p>
                            <ul>
                                <li>UNE 23300:1984, CE, WEEE, RoHS standards</li>
                                <li>High gas identification accuracy with electrochemical CO sensor</li>
                                <li>Up to 1 ppm resolution, less than 5% measurement error</li>
                                <li>Short reaction time</li>
                                <li>No calibration required</li>
                                <li>Low current consumption</li>
                                <li>Status indicator LED</li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 31,
                    name: 'CARBONMONOXIDE CONTROL PANEL ',
                    hide: true,
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/karbonmonoksit_yangin_alarm_sistemleri/2.jpg',
                        // process.env.PUBLIC_URL + '/images/products/karbonmonoksit_yangin_alarm_sistemleri/2.jpg',
                    ],
                    content: '',
                    link: '/product/6/30/karbonmonoksit_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <p>It is designed for carbon monoxide detection and automatic control of exhaust fans for indoor parking areas. CO Detection Control Panels are designed for CO detection in parking areas where carbon monoxide (CO) concentration occurs.</p>
                            <p>KM300 series control panels are available as individually controllable and supervised 1, 2, 3 or 4 zones.</p>
                            <p>The KM300 CO Control Panel can be used in large and small scale projects. Each zone can control an area of 4500 m², and CO detection can be made up to 18000 m² if a 4-zone panel is used.</p>
                            <p>A maximum of 15 CO detectors can be connected on a 3-core 1.5 mm² cable for each zone. In addition, 2 ventilation/exhaust relays and 1 general alarm relay for each zone can be defined according to separately programmable CO levels.</p>
                            <p>Microprocessor based KMD300 detectors are used as field device compatible with the panel. The CO detection range is between 0 - 300 ppm. A flashing green light on the detector indicates normal operating status. On the other hand, the constantly lit red light gives a visual indication of a CO concentration above 50 ppm. Flashing red light indicates fault status. All CO panels and CO detector have CE, WEEE and RoHS compliance certificates.</p>
                        </figure>

                    </div>
                },
                {
                    id: 2,
                    name: 'OPTICAL SMOKE DEDECTOR',
                    hide: true,
                    imgsrc: [

                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-231.png',


                    ],
                    content: '',
                    link: '/product/6/2/adresli_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            {/* <figcaption>CLASS A FIRE</figcaption> */}
                            <p> Fire Detection Detectors’ Nova-AOD Intelligent Addressable Optical Smoke Detector contains High Technological Features with it’s New Design. Built-in isolator is available.

                                Smoke Detector Levels: Pollution, Pre-Alarm (Off at factory settings), High, Normal, Low sensitivity, Day/night.</p>
                        </figure>

                    </div>
                },
                {
                    id: 3,
                    name: 'STANDARD DEDECTOR SOCKET',
                    hide: true,
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-232.png',
                    ],
                    content: '',
                    link: '/product/6/3/adresli_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            {/* <figcaption>CLASS A FIRE</figcaption> */}
                            <ul>
                                <li>Weight: 40 gr.</li>
                                <li>Dimensions: Q105 mm, h 100 mm (+%0,5)</li>
                                <li>Color: White</li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 4,
                    name: 'ADRESSABLE FIRE ALARM CALL POINT',
                    hide: true,
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-233.png',
                    ],
                    content: '',
                    link: '/product/6/4/adresli_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            {/* <figcaption>CLASS A FIRE</figcaption> */}
                            <p>
                                Intelligent Addressable Fire Detection Call Point  Nova-AMCP provides optimum use with it’s easy assembly and setup. In Fire Detection systems, they are devices that enable the alarm to be triggered manually in the case of a fire. It is a model that can be reset with it’s Special Key. Stylish and easy to use design. It has the feature of using built-in type. There is an internal isolator.
                            </p>
                            <p>
                                Yellow and Green Colors Available.
                            </p>
                            <p>
                                Optional transparent cover option is available.
                            </p>
                            <p>
                                Certified with EN54-11 and EN54-17 Standards.
                            </p>
                        </figure>

                    </div>
                },
                {
                    id: 5,
                    name: 'ADRESSABLE FIRE ALARM SOUNDER',
                    hide: true,
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-234.png',
                    ],
                    content: '',
                    link: '/product/6/5/adresli_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            {/* <figcaption>CLASS A FIRE</figcaption> */}
                            <p>
                            Addressable Sounder have been developed for audible warning in case of alarm. With aesthetic look, high sound and low current consumption it is used in integrated with addressable system.
                            </p>
                           <p>
                           It supports a maximum of 105 Db - m (A) at a distance of 1 m with 8 tones and 32 melodies. Built-in isolator is available.
                           </p>
                            <p>
                            Certified with EN54-3 and EN54-17 Standards.
                            </p>
                        </figure>

                    </div>
                },
                {
                    id: 6,
                    name: 'ADRESSABLE FIRE ALARM SOUNDER WITH FLASHER',
                    hide: true,
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-235.png',
                    ],
                    content: '',
                    link: '/product/6/6/adresli_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            {/* <figcaption>CLASS A FIRE</figcaption> */}
                            <p>
                            Addressable Sounder with  Flasher has been developed to give both audible and visual warning in case of alarm. With aesthetic look, high sound and low current consumption it is used in integrated with addressable system. With the new generation flasher technology, you have the maximum light option. It gives a maximum of 105 dB-m (A) sound from a distance of 1 m with 8 tones and 32 melodies of support. There is an internal isolator.
                            </p>
                            <p>
                            Certified with EN54-3, EN54-23 and EN54-17 Standards.
                            </p>
                        </figure>

                    </div>
                },
                {
                    id: 8,
                    name: 'LPG & NATURAL GAS DEDECTOR ',
                    hide: true,
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/adresli_yangin_alarm_sistemleri/image-237.png',
                    ],
                    content: '',
                    link: '/product/6/8/adresli_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            {/* <figcaption>CLASS A FIRE</figcaption> */}
                            <p>
                            Addressable gas detector, LPG and natural gas detector with relay output, built-in buzzer, sound and light warning, test button, modern design, wall mount, including wall mount apparatus for home and offices.
                            </p>
                            <p>
                            12/24 VDC option is available. Requires external 24V supply.
                            </p>
                            <p>
                            It has EN50194-1, EN54-17 standards and GAZMER approval.
                            </p>
                        </figure>

                    </div>
                },
            ]
        }
    },
    {
        category: {
            id: 7,
            name: 'CLEAN AGENT SYSTEMS ',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/fm_200_fe227_(HFC227ea)_gazli_sondurme_sistemi/image-248.png'],
            content: 'FM 200, CO2 gas and in-panel automatic extinguishing systems.',
            link: '/category/gazli_sondurme_sistemi/7/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'FM200 –FE 227 (HFC 227 ) CLEAN AGENT EXTINGUISHING SYSTEM',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/fm_200_fe227_(HFC227ea)_gazli_sondurme_sistemi/image-248.png'],
                    content: '',
                    link: '/product/7/0/adresli_yangin_alarm_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>FM200 Gas System Components</figcaption>
                            <p>It consists of FM 200 chemical agent and four main components and the accessories of these components. </p>
                            <ul>
                                <li><b>FM-200 Components  :</b> It consists of the cylinder in which FM-200 gas is stored, the cylinder protector and the FM 200 discharge nozzle. </li>
                                <li><b>Control Panel:</b> It is the brain of the system, it is used to view, monitor and activate the detection system and equipment. </li>
                                <li><b>Warning Elements :</b> Detection detectors and accessories in the system, sirens giving audible and visual warnings are external equipment that performs the eye and ear functions of the system.</li>
                                <li><b>Supplementary Equipment :</b> Consists of warning signs, hoses, connection fittings, pressure manometers or solenoid valve and actuator required to operate the cylinder valve.</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>System Design and Operation</figcaption>
                            <p>For the volume to be protected with FM 200, the required gas amount is calculated according to the NFPA 12 and TS ISO 14520 standards and rules, FM 200 tube is selected according to the gas amount, FM-200 discharge nozzles are placed at the required points in the room equipped with cross-zone fire detection system, Smoke With the activation of the detectors, a current is sent from the panel to the solenoid valve of the FM-200 system. All FM 200 gas is discharged to the protected volume within a maximum of 10 seconds.</p>
                            <p>The operation of the system can be done automatically or manually. Gas stationary extinguishing systems comply with TS ISO 14520 "Gas Extinguishing Systems - Physical Properties and System Design" and TS EN 15004 "Fixed Fire Fighting Systems - Gas Spraying Systems - Design, Installation and Maintenance" standards, which must be complied with depending on the qualifications and needs of the facility. is designed accordingly.
                            </p>
                        </figure>
                        <figure>
                            <figcaption>Where Used:</figcaption>
                            <ul>
                                <li>Computer, server rooms</li>
                                <li>Telephone and telecommunications rooms</li>
                                <li>Electricity distribution rooms / centers</li>
                                <li>Valuable material warehouses</li>
                                <li>Laboratories</li>
                                <li>Bank vaults, Archives, Libraries</li>
                                <li>Museums and art galleries</li>
                                <li>Turbine cabins etc. FM 200 gas can be used safely </li>
                            </ul>
                        </figure>
                        <figure>
                            {/* <figcaption>A Sınıfı Yangınlar</figcaption> */}
                            <p> FM-200 is an alternative gas to Halon, which was put on the market after the ban on the use of Halon 1301 gas and was the most widely used. Its chemical name is Heptafluoropropane. FM 200 gas extinguishes fires with its ability to break chemical reactions and absorb heat energy. FM 200 gas extinguishing systems are recommended if there is at least one of the following conditions: If the value of the material in the protected area or its importance in terms of business continuity requires a fire system that will be activated within seconds. If the sprinkler system will damage the material in the protected area. If there are people in the protected area. If post-fire cleaning is desired to be eliminated. If there is a need for easy design and installation. FM200 Gas System Properties It is colorless, odorless and an insulating extinguishing agent. Ozone destruction coefficient is zero, Atmospheric life is 31-42 years. It physically extinguishes. After the gas is discharged, it does not leave any residue, there is no need for cleaning, The gas spreads to the atmosphere. It can be used safely in places with people. It is the most widely used Halon 1301 alternative. It is economical. It occupies little space. The discharge time is 10 seconds.</p>
                        </figure>

                    </div>
                },
                {
                    id: 1,
                    name: 'IN –PANEL AUTOMATIC EXTINGUISHING SYSTEM ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/pano_ici_gazli_otomatik_sondurme_sistemleri/image-250.png'],
                    content: '',
                    link: '/product/7/1/pano_ici_gazli_otomatik_sondurme_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <figcaption>Where Used:</figcaption>
                            <ul>
                                <li>Electric panels</li>
                                <li>UPS Cabinets</li>
                                <li>Telephone Exchange Cabinets</li>
                                <li>Armored Vehicle Engine Compartments</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>What is In-Panel Extinguishing System? </figcaption>
                            <p>It is an automatic system with a flexible red detection hose that ends the self-starting fire where it started. The detection hose is made of polymer mixture materials in order to work in the best way. It protects the fire area not from a number of places, but from wherever the detection hose passes. This system can work alone as well as with an alarm system or a system off switch. These features eliminate all risks.</p>
                            <figcaption>Why is it so effective?</figcaption>
                            <p>Because the detection hose passes from all sides of the place to be protected, it detects and extinguishes the fire from the central place, that is, from the first place. The sensing hose is unaffected by moisture, dirt and irregular airflow. It does its job of detection in all conditions. The pressurized sensing hose is placed inside the protected area. At the time of fire, the hose on the side of the fire source melts and explodes when it senses the small fire. The extinguishing agent evacuates from the explosion and extinguishes the fire while it is in the form of a smaller flame. An optionally adapted alarm system is also activated. The system can be installed in a wide variety of sizes and lengths.</p>
                        </figure>

                    </div>
                },
                {
                    id: 2,
                    name: 'CARBONDIOXIDE EXTINGUISHING SYSTEMS ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/co2_gazli_sondurme_sistemleri/image-251.png'],
                    content: '',
                    link: '/product/7/2/co2_gazli_sondurme_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>Features</figcaption>
                            <ul>
                                <li>It does not harm ozone.</li>
                                <li>It physically extinguishes.</li>
                                <li>Used for local extinguishing</li>
                                <li>Cannot be used in places with people</li>
                                <li>Low cost of refilling, fire widely available</li>
                                <li>Discharge time is 60-120 seconds. (30 seconds for local systems)</li>
                                <li>Low pressure systems: Low pressure carbon dioxide systems are used in total volume protection applications where high amounts of extinguishers are needed.</li>
                                <li>High pressure systems: High pressure carbon dioxide systems are used in both total volume protection and local protection applications.</li>

                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Where Used</figcaption>
                            <ul>
                                <li>Power transmission rooms</li>
                                <li>Generator power sets</li>
                                <li>Engine rooms</li>
                                <li>Registration rooms</li>
                                <li>Cable and installation galleries</li>
                                <li>Electricity distribution rooms/centers</li>
                                <li>Computer rooms</li>
                                <li>Combustible liquid storage areas</li>
                                <li>Painting booths</li>
                                <li>Archives</li>
                                <li>Printing Houses</li>
                                <li>Industrial Ovens</li>
                                <li>Large Commercial Cooking Areas</li>
                                <li>And many more end. applications</li>

                            </ul>
                            <p>Materials for which Carbon Dioxide (CO2) Gas Suppression System cannot be used. Oxygen-containing chemicals such as cellulose nitrate, reactive metals such as sodium, potassium, magnesium, titanium and zirconium, metal hydrates.
                            </p>
                        </figure>
                        <figure>
                            {/* <figcaption>Kullanildigi Yerler:</figcaption> */}
                            <p>It is the oldest and most common gas used in gas extinguishing systems. It is the only gas used in local applications and is used as the most effective solution especially in areas where chemicals are present. It is undesirable to use in places where delicate electrical and electronic devices are located due to its cooling effect, and in human spaces due to its suffocating effect. CO2 gas extinguishes fires by reducing the relative oxygen density in the extinguishing environment below the oxygen density level required for the fire to continue.</p>
                            <p>Carbon dioxide; It is a colorless, odorless, non-electrically conductive inert gas suitable for fire extinguishing.</p>
                            <p>Carbon dioxide extinguishes the combustion by reducing the oxygen in the air and/or the concentration of a fuel in the gas phase to the point where the combustion stops.</p>
                        </figure>

                    </div>
                },

            ]
        }
    },
    {
        category: {
            id: 8,
            name: 'KITCHEN HOOD SUPRESSION SYSTEM',
            imgsrc: [
                process.env.PUBLIC_URL + '/images/products/otomatik_davlumbaz_sondurme_sistemleri/2.jpg',

            ],
            content: 'Automatic hood extinguishing systems designed according to UL 300 Standard and in accordance with NFPA 96, NFPA 17 A.',
            link: '/category/otomatik_davlumbaz_sondurme_sistemleri/8/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'AUTOMATIC HOOD SUPRESSION SYSTEM',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/otomatik_davlumbaz_sondurme_sistemleri/image-252.png',
                        process.env.PUBLIC_URL + '/images/products/otomatik_davlumbaz_sondurme_sistemleri/2.jpg',
                    ]
                    ,
                    content: '',
                    link: '/product/8/0/otomatik_davlumbaz_sondurme_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical  Details</h2>
                        <figure>
                            <figcaption>REGULATION ON PROTECTION OF BUILDINGS FROM FIRE 09.09.2009 / 27344</figcaption>
                            <p>ARTICLE 57- (1) With the exception of residences, an automatic extinguishing system should be installed in the hoods of shopping malls, kitchens and food factories in high-rise buildings and kitchens that serve more than 100 people at a time, and gas detection, gas cut-off and gas detection according to the characteristics of the gas used in the stoves. A warning system must be installed.</p>
                        </figure>
                        <figure>
                            <figcaption>Auxiliary Staff</figcaption>
                            <ul>
                                <li>MANUAL DISCHARGE HANDLE: Allows the system to be emptied manually. </li>
                                <li>GAS STOP VALVE: In case of fire, it prevents more fuel from entering the room.</li>
                                <li>ELECTRICAL CONTACT: It is used to signal the alarm system or to turn off the electrical appliances in the kitchen. Hood Extinguishing Systems </li>
                                <p>APPROVED: If the hood extinguishing system is not included in TSE standards to determine the criteria for design, installation and material properties, European Union standards or UL300 standards should be considered first.
                                    Hood Extinguishing Systems are designed according to the UL300 standard and must comply with NFPA 96, NFPA 17A.
                                </p>
                                <li>AESTHETICS: The equipment of the hood extinguishing system inside the hood is made of chrome-plated, brass or stainless materials and has an elegant appearance. The hood extinguishing liquid extinguisher does not damage the kitchen equipment with its low PH level and can be easily cleaned.</li>
                            </ul>
                        </figure>
                        <figure>
                            <p>Small kitchen fires in various parts of the world every year become threatening to the whole building because the necessary precautions are not taken. Therefore, a small kitchen fire can be found in a shopping mall, hotel, etc. Since it damages all buildings, it causes millions of dollars in financial loss as well as job and service loss. Taking precautions in an extremely simple and economical way provides a great deal of success in preventing damage.</p>
                            <p>AUTOMATIC: As a result of the activation of the discharge mechanism detection line, it allows the potassium carbonate-based liquid extinguisher with low PH level, specially developed for hot oil fires, to be discharged quickly from the discharge line.</p>
                            <p>FAST: Thanks to the fusible metal detectors placed inside the hood, it detects the fire very quickly.</p>
                            <p>EFFECTIVE EXTINGUISHING: The extinguishing liquid is discharged through nozzles, allowing the fire to be extinguished quickly and effectively. The liquid extinguisher creates a foam blanket on hot oil fires and cuts the contact of the flames with oxygen.</p>
                        </figure>

                    </div>
                },
            ]
        }
    },
    {
        category: {
            id: 9,
            name: 'FIRE VALVES ',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_vana_gruplari/image-257.png'],
            content: 'UL & FM approved, İndicating butterfly valves, test & drain valves, flow switches, check valves, rising stem valves.',
            link: '/category/yangin_vana_gruplari/9/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'INDICATING BUTTERFLY VALVE',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_vana_gruplari/image-257.png'],
                    content: '',
                    link: '/product/9/0/yangin_vana_gruplari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <ul>
                                <li>Connection Diameter: 1” – 8” </li>
                                <li>Connection Type: Threaded, Wafer,Grooved </li>
                                <li>Working Pressure: 300 PSI (21.4 bar) </li>
                                <li>Test Pressure: 600 PSI (42.8 bar) </li>
                                <li>Operating Temperature: 0°C -120°C</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 1,
                    name: 'TEST & DRAIN VALVE',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_vana_gruplari/image-258.png'],
                    content: '',
                    link: '/product/9/1/yangin_vana_gruplari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>

                            <ul>
                                <li>Connection Diameter: 1”, 1¼”, 2”</li>
                                <li>Connection Type: Threaded Working </li>
                                <li>Pressure: 300 PSI (21.4 bar) </li>
                                <li>K Orifis: 40, 60, 80, 115, 160, 200, 242, 320, 360</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 2,
                    name: 'FLOW SWICTH',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_vana_gruplari/image-259.png'],
                    content: '',
                    link: '/product/9/2/yangin_vana_gruplari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <ul>
                                <li>Connection Diameter: 1”- 2”, 2”- 8”</li>
                                <li>Connection Type: Threaded, U-Bolt</li>
                                <li>Working Pressure: 300 PSI (21.4 bar), 450 PSI (31 bar)</li>
                                <li>Flow Range Required for Alarm: 4-10 gpm</li>
                                <li>Max Ripple: 18fps</li>
                                <li>Operating Temperature: 0°C- 66°C</li>
                                <li>Cable Entry: Two openable ½” cable channels</li>
                                <li>Contact Ratings: Two sets of spdt 10.0 a@125/250 vac 2.0 a@ 30 vdc 10m a mn @24vdc</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 3,
                    name: 'OS&Y GATE VALVE ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_vana_gruplari/image-253.png'],
                    content: '',
                    link: '/product/9/3/yangin_vana_gruplari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <ul>
                                <li>Connection Diameter: 1”- 2”, 2½”-12”  </li>
                                <li>Connection Type: Threaded, Flanged Working </li>
                                <li>Pressure: 175 PSI (12 bar), 250 PSI (17.2 bar) </li>
                                <li>Operating Temperature: -10°C- 120°C</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 4,
                    name: 'CHECK VALVE ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_vana_gruplari/image-255.png'],
                    content: '',
                    link: '/product/9/4/yangin_vana_gruplari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <ul>
                                <li>Connection Diameter: 1”-2”(threaded), 2”- 8”(Groved), 4”-12”(Wafer) </li>
                                <li>Connection Type: Threaded,Groove,wafer </li>
                                <li>Wafer Working Pressure: 175 PSI (12 bar), 300 PSI (20.7 bar) </li>
                                <li>Operating Temperature: 0°C - 120°C</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 5,
                    name: 'RELIEF VALVE ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_vana_gruplari/image-260.png'],
                    content: '',
                    link: '/product/9/5/yangin_vana_gruplari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <ul>
                                <li>Connection Diameter: ½”-¾”(Threaded), 2”- 10”(Flanged) </li>
                                <li>Connection Type: Threaded, Flanged</li>
                                <li>Pressure Class: 175 PSI max, 400 PSI max. </li>
                                <li>Operating Temperature: 0°C- 82°  </li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 6,
                    name: 'PRESSURE REDUCING VALVE',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_vana_gruplari/image-254.png'],
                    content: '',
                    link: '/product/9/6/yangin_vana_gruplari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <ul>
                                <li>Connection Diameter: ½”-¾”(Threaded), 2”- 10”(Flanged)</li>
                                <li>Connection Type: Threaded, Flanged</li>
                                <li>Pressure Class: 175 PSI max, 400 PSI max.</li>
                                <li>Operating Temperature: 0°C- 82°  </li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 7,
                    name: 'FLOW METER ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_vana_gruplari/image-261.png'],
                    content: '',
                    link: '/product/9/7/yangin_vana_gruplari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <ul>
                                <li>Connection Diameter: 1¼”-2” (Threaded), 2½” – 12” (Butt welded and Grooved)</li>
                                <li>Connection Type: Threaded, Butt Welded, Grooved</li>
                                <li>Working Pressure: 500 Psi</li>
                                <li>Operating Temperature: 0°C- 82°</li>
                            </ul>
                        </figure>


                    </div>
                },
            ]
        }
    },
    {
        category: {
            id: 10,
            name: 'FIRE SPRINKS ',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_sprinkleri/image-262.png'],
            content: 'UL & FM approved pendent, side Wall, upright type fire sprinklers.',
            link: '/category/yangin_sprinkleri/10/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'UPRIGHT SPRINKLER',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_sprinkleri/3.jpg'],
                    content: '',
                    link: '/product/10/0/yangin_sprinkleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <p>It is the sprinkler that is connected in such a way that the water is directed upwards from the deflector.</p>
                            <figcaption>General features</figcaption>
                            <ul>
                                <li>Color: Chrome, Brass</li>
                                <li>Operating Temperature: 57 °C, 68 °C, 79 °C,93 °C,141 °C.</li>
                                <li>Connectable Dimensions: ½''- ¾''-1''</li>
                                <li>Working Pressure: 175 ps (12.1 bar)</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 1,
                    name: 'SIDEWALL SPRINKLER',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_sprinkleri/image-263.png'],
                    content: '',
                    link: '/product/10/1/yangin_sprinkleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <p>It is a sprinkler with a special deflector that discharges outward from the wall in a semi-parabolic way.</p>
                            <figcaption>General features</figcaption>
                            <ul>
                                <li>Color: White, Chrome, Brass</li>
                                <li>Operating Temperature: 57 °C, 68 °C, 79 °C,93 °C,141 °C.</li>
                                <li>Connectable Dimensions: ½''- ¾''-1''</li>
                                <li>Working Pressure: 175 ps (12.1 bar)</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 2,
                    name: 'PENDENT SPRINKLER ',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/yangin_sprinkleri/image-262.png',
                        process.env.PUBLIC_URL + '/images/products/yangin_sprinkleri/image-264.png',
                    ],
                    content: '',
                    link: '/product/10/2/yangin_sprinkleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <p>It is the sprinkler that is connected in such a way that the water is directed downwards from the deflector.</p>
                            <figcaption>General features</figcaption>
                            <ul>
                                <li>Color: Chrome, Brass</li>
                                <li>Operating Temperature: 57 °C, 68 °C, 79 °C,93 °C,141 °C.</li>
                                <li>Connectable Dimensions: ½''- ¾''-1''</li>
                                <li>Working Pressure: 175 ps (12.1 bar)</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 3,
                    name: 'CONCEALED PENDENT SPRINKLER',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/yangin_sprinkleri/image-266.png',
                        process.env.PUBLIC_URL + '/images/products/yangin_sprinkleri/image-267.png',
                    ],
                    content: '',
                    link: '/product/10/3/yangin_sprinkleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <p>It is the sprinkler that is connected in such a way that the water is directed downwards from the deflector.</p>
                            <figcaption>General features</figcaption>
                            <ul>
                                <li>K-Factor: 40.3 (2.8), 57 (4.2), 80 (5.6), 115 (8.0), 160(11.2)</li>
                                <li>Bulb: 3mm Glass </li>
                                <li>Connection Diameter: ½”NPT – ¾”NPT</li>
                                <li>Temperature: 68 °C, 74 °C, 93 °C, 96 °C</li>
                                <li>Surface: Brass</li>
                                <li>Cover Color: Brass, Chrome, White, Black</li>
                                <li>Pressure Class: 175~250ps</li>
                                <li>Hazard Class: Mild and Medium Hazard</li>
                                <li>Mounting Type: Parallel to the ground</li>
                            </ul>
                        </figure>


                    </div>
                },
            ]
        }
    }
    ,
    {
        category: {
            id: 11,
            name: 'HYDRANT AND BREECHING INLETS',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/hidrant_ve_itfaiye_baglanti_agizlari/image-284.png'],
            content: 'Fire hydrants in accordance with TS 2821/1 standard, UL & FM approved Breeching inlets.',
            link: '/category/hidrant_ve_itfaiye_baglanti_agizlari/11/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'HYDRANT',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/hidrant_ve_itfaiye_baglanti_agizlari/image-281.png',
                        process.env.PUBLIC_URL + '/images/products/hidrant_ve_itfaiye_baglanti_agizlari/image-284.png',
                    ],
                    content: '',
                    link: '/product/11/0/hidrant_ve_itfaiye_baglanti_agizlari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>

                        <figure>
                            <p>It is produced as Aboveground and Underground</p>

                        </figure>
                        <figure>
                            <figcaption>ABOVE GROUND  HYDRANT SIZE TABLE </figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>DN (Nominal Diameter) </th>
                                        <th>Length </th>
                                        <th>H1 (mm)</th>
                                        <th>H2 (mm)</th>
                                        <th>H3 (mm)</th>
                                        <th>H4 (mm)</th>
                                        <th>H (mm)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>İY_001_H</td>
                                        <td>Q 80</td>
                                        <td>Short</td>
                                        <td>200</td>
                                        <td>880</td>
                                        <td>-</td>
                                        <td>370</td>
                                        <td>1450</td>
                                    </tr>
                                    <tr>
                                        <td>İY_002_H</td>
                                        <td>Q 80</td>
                                        <td>Tall Length</td>
                                        <td>200</td>
                                        <td>880</td>
                                        <td>300</td>
                                        <td>370</td>
                                        <td>1750</td>
                                    </tr>
                                    <tr>
                                        <td>İY_003_H</td>
                                        <td>Q 100</td>
                                        <td>Short</td>
                                        <td>200</td>
                                        <td>880</td>
                                        <td>-</td>
                                        <td>370</td>
                                        <td>1450</td>
                                    </tr>
                                    <tr>
                                        <td>İY_004_H</td>
                                        <td>Q 100</td>
                                        <td>Tall Length</td>
                                        <td>200</td>
                                        <td>880</td>
                                        <td>300</td>
                                        <td>370</td>
                                        <td>1750</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>

                    </div>
                },
                {
                    id: 1,
                    name: 'BREECHING INLETS –UL&FM APPROVED ',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/hidrant_ve_itfaiye_baglanti_agizlari/image-278.png',
                        process.env.PUBLIC_URL + '/images/products/hidrant_ve_itfaiye_baglanti_agizlari/image-280.png',
                        process.env.PUBLIC_URL + '/images/products/hidrant_ve_itfaiye_baglanti_agizlari/image-279.png',
                    ],
                    content: '',
                    link: '/product/11/1/hidrant_ve_itfaiye_baglanti_agizlari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <ul>
                                <li>Connection Type: Threaded</li>
                                <li>Connectable Dimensions: 4''*2 ½''*2 ½''</li>
                                <li>Equipment: Storz Cover, Drip Valve, Wall Plate</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 2,
                    name: 'BREECHING INLETS(LOCAL PRODUCT )',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/hidrant_ve_itfaiye_baglanti_agizlari/image-283.png',

                    ],
                    content: '',
                    link: '/product/11/2/hidrant_ve_itfaiye_baglanti_agizlari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <ul>
                                <li>Connection Type: Threaded</li>
                                {/* <li>Bağlantı Yapılabilen Dimensions: 4''*2 ½''*2 ½'' || 2 ½''*2 ½''* 2 1/2'' || 2 ½''*2 ½''* 2''</li> */}

                                <li>Connectable Dimensions
                                    <ul>
                                        <od>4''*2 ½''*2 ½''</od>
                                        <br />
                                        <od>2 ½''*2 ½''* 2 ½''</od>
                                        <br />
                                        <od>2 ½''*2 ½''* 2''</od>
                                    </ul>
                                </li>



                                <li>Equipment: Storz Cover</li>
                            </ul>
                        </figure>
                        {/* <figure>
                            <figcaption>Bağlantı Yapılabilen Dimensions</figcaption>
                            <ul>
                               <li>4''*2 ½''*2 ½''</li>
                               <li>2 ½''*2 ½''* 2 1/2''</li>
                               <li>2 ½''*2 ½''* 2''</li>
                             
                            </ul>
                        </figure> */}

                    </div>
                },
                {
                    id: 3,
                    name: 'LANDING VALVES(LOCAL CERTIFIED)',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/hidrant_ve_itfaiye_baglanti_agizlari/image-277.png',

                    ],
                    content: '',
                    link: '/product/11/3/hidrant_ve_itfaiye_baglanti_agizlari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <ul>
                                <li>Connection Type: Threaded</li>
                                <li>Connectable Dimensions: [2 ½''*2 ½'' 2''] & [2 1/2'' 2'' * 2 '']</li>
                                <li>Equipment: Storz Cover</li>
                            </ul>
                        </figure>


                    </div>
                },
                {
                    id: 4,
                    name: 'UL& FM ONAYLI –LANDING VALVES (UL&FM APPROVED )',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/hidrant_ve_itfaiye_baglanti_agizlari/image-276.png',

                    ],
                    content: '',
                    link: '/product/11/4/hidrant_ve_itfaiye_baglanti_agizlari',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <ul>
                                <li>Connection Type: Threaded</li>
                                <li>Connectable Dimensions: 2 ½''*2 ½''</li>
                                <li>Equipment: Storz Cover</li>
                            </ul>
                        </figure>


                    </div>
                },
            ]
        }
    }
    ,
    {
        category: {
            id: 12,
            name: 'EMERGENCY LIGHTING AND EXIT LIGHTS',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/image-269.png'],
            content: '',
            link: '/category/acil_aydinlatma_ve_yonlendirme_armaturleri/12/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'SG002 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg002-cift-yonlu-acil-yonlendirme-armaturu__3774-1.jpg'],
                    content: '',
                    link: '/product/12/0/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Exit Exit Right-Left Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 1,
                    name: 'SG003 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg139-tek-yonlu-acil-aydinlatma-armaturu__3817-1.jpg'],
                    content: '',
                    link: '/product/12/1/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Exit Exit Right-Left Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 2,
                    name: 'SG004 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg004-cift-yonlu-acil-yonlendirme-armaturu__3772-1.jpg'],
                    content: '',
                    link: '/product/12/2/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Right-Left Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 3,
                    name: 'SG005 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg005-cift-yonlu-acil-yonlendirme-armaturu__3771-1.jpg'],
                    content: '',
                    link: '/product/12/3/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Exit Down Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 5,
                    name: 'SG007 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg007-cift-yonlu-acil-yonlendirme-armaturu__3767-1.jpg'],
                    content: '',
                    link: '/product/12/5/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Exit Down Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 6,
                    name: 'SG010 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg010-cift-yonlu-acil-yonlendirme-armaturu__3766-1.jpg'],
                    content: '',
                    link: '/product/12/6/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Man WC</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 7,
                    name: 'SG011 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg011-cift-yonlu-acil-yonlendirme-armaturu__3765-1.jpg'],
                    content: '',
                    link: '/product/12/7/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Woman WC</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 8,
                    name: 'SG012 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/fotomat-sg012-isikli-wc-yonlendirme-tabelasi-levhasi__1484630227065435.webp'],
                    content: '',
                    link: '/product/12/8/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Man Woman WC</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 28,
                    name: 'SG125 One Way Emergency Exit Light ',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg125-tek-yonlu-acil-yonlendirme-armaturu__3770-1.jpg'],
                    content: '',
                    link: '/product/12/28/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>Rechargeable with green led bulb</li>
                                <li>One Way</li>
                                <li>Continuous lighting , 3 hours working feature in power cut</li>
                                <li>Left direction</li>
                                <li>Voltage:220V AC</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Wattage:3W</li>
                                <li>IP:20</li>
                                <li>Number of boxes: 10</li>
                                <li>Certificate:CE</li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 29,
                    name: 'SG126 One Way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg126-tek-yonlu-acil-aydinlatma-armaturu__3815-1.jpg'],
                    content: '',
                    link: '/product/12/29/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>Rechargeable with green led bulb</li>
                                <li>One Way</li>
                                <li>Continuous lighting , 3 hours working feature in power cut</li>
                                <li>Right direction</li>
                                <li>Voltage:220V AC</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Wattage:3W</li>
                                <li>IP:20</li>
                                <li>Number of boxes: 10</li>
                                <li>Certificate:CE</li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 30,
                    name: 'SG127 One Way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg127-tek-yonlu-acil-aydinlatma-armaturu__4934-1.jpg'],
                    content: '',
                    link: '/product/12/30/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>Rechargeable with green led bulb</li>
                                <li>One Way</li>
                                <li>Continuous lighting , 3 hours working feature in power cut</li>
                                <li>Down direction </li>
                                <li>Voltage:220V AC</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Wattage:3W</li>
                                <li>IP:20</li>
                                <li>Number of boxes: 10</li>
                                <li>Certificate:CE</li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 31,
                    name: 'SG128 One Way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg128-tek-yonlu-acil-aydinlatma-armaturu__3816-1.jpg'],
                    content: '',
                    link: '/product/12/31/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>Rechargeable with green led bulb</li>
                                <li>One Way</li>
                                <li>Continuous lighting , 3 hours working feature in power cut</li>
                                <li>Up direction</li>
                                <li>Voltage:220V AC</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Wattage:3W</li>
                                <li>IP:20</li>
                                <li>Number of boxes: 10</li>
                                <li>Certificate:CE</li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 32,
                    name: 'SG139 One Way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg139-tek-yonlu-acil-aydinlatma-armaturu__3817-1 (1).jpg'],
                    content: '',
                    link: '/product/12/32/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>Rechargeable with green led bulb</li>
                                <li>One Way</li>
                                <li>Continuous lighting , 3 hours working feature in power cut</li>
                                <li>Exit çıkış yön</li>
                                <li>Voltage:220V AC</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Wattage:3W</li>
                                <li>IP:20</li>
                                <li>Number of boxes: 10</li>
                                <li>Certificate:CE</li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 9,
                    name: 'SG155 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg155-cift-yonlu-acil-yonlendirme-armaturu__3763-1.jpg'],
                    content: '',
                    link: '/product/12/9/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Merdivenli Sağ-Sol Ok</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 10,
                    name: 'SG156 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg156-cift-yonlu-acil-yonlendirme-armaturu__3762-1.jpg'],
                    content: '',
                    link: '/product/12/10/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Stepper Down Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 11,
                    name: 'SG157 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg157-cift-yonlu-acil-yonlendirme-armaturu__3761-1.jpg'],
                    content: '',
                    link: '/product/12/11/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Stepper Up Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 12,
                    name: 'SG013 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg013-cift-yonlu-acil-yonlendirme-armaturu__3760-1.jpg'],
                    content: '',
                    link: '/product/12/12/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Left-Right Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 13,
                    name: 'SG014 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg014-cift-yonlu-acil-yonlendirme-armaturu__3759-1.jpg'],
                    content: '',
                    link: '/product/12/13/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Down Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 14,
                    name: 'SG015 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg015-cift-yonlu-acil-yonlendirme-armaturu__3758-1.jpg'],
                    content: '',
                    link: '/product/12/14/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Up Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 15,
                    name: 'SG016 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg016-cift-yonlu-acil-yonlendirme-armaturu__3757-1.jpg'],
                    content: '',
                    link: '/product/12/15/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Exit</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 16,
                    name: 'SG017 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg017-cift-yonlu-acil-yonlendirme-armaturu__3756-1.jpg'],
                    content: '',
                    link: '/product/12/16/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Exit</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 17,
                    name: 'SG018 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg018-cift-yonlu-acil-yonlendirme-armaturu__3809-1.jpg'],
                    content: '',
                    link: '/product/12/17/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Exit </li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 18,
                    name: 'SG019 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg019-cift-yonlu-acil-yonlendirme-armaturu__3810-1.jpg'],
                    content: '',
                    link: '/product/12/18/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Stepper Up Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 19,
                    name: 'SG020 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg020-cift-yonlu-acil-yonlendirme-armaturu__3811-1.jpg'],
                    content: '',
                    link: '/product/12/19/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Stepper Down Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 20,
                    name: 'SG021 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg021-cift-yonlu-acil-yonlendirme-armaturu__3812-1.jpg'],
                    content: '',
                    link: '/product/12/20/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Stepper Left-Right Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 21,
                    name: 'SG022 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg022-cift-yonlu-acil-yonlendirme-armaturu__3813-1.jpg'],
                    content: '',
                    link: '/product/12/21/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Left-Right Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 22,
                    name: 'SG023 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg023-cift-yonlu-acil-yonlendirme-armaturu__4953-1 (1).jpg'],
                    content: '',
                    link: '/product/12/22/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Acil Çıkış Sağ-Sol Ok</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 23,
                    name: 'SG024 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg024-cift-yonlu-acil-yonlendirme-armaturu__4954-1.jpg'],
                    content: '',
                    link: '/product/12/23/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Exit Down Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 24,
                    name: 'SG025 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg025-cift-yonlu-acil-yonlendirme-armaturu__4955-1.jpg'],
                    content: '',
                    link: '/product/12/24/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Exit Up Arrow</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 25,
                    name: 'SG160 Two-way Emergency Exit Light',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/sg160-cift-yonlu-acil-yonlendirme-armaturu__3814-1.jpg'],
                    content: '',
                    link: '/product/12/25/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>GENERAL FEATURES OF EMERGENCY DIRECTION FIXTURES</figcaption>
                            <ul>
                                <li>It is activated automatically when the electricity is cut off. It has a 3-hour working time.</li>
                                <li>Usage areas: workplaces, workshops, apartments, factories and facilities, hospitals, shopping malls, schools, government offices.</li>
                                <li>It is mounted to the ceiling with hanging loops. </li>
                                <li>It helps you find your way in the dark with the light it emits when the electricity is out.</li>
                                <li>There are 6 LEDs in the products and a 1.2 Volt rechargeable battery is included in the products.</li>
                                <li>It is bidirectional.</li>
                                <li>Dimensions: 14cm Height x 35 cm Width x 2.5 cm Depth</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>TECHNICAL SPECIFICATIONS OF EMERGENCY EXIT LIGHTS</figcaption>
                            <ul>
                                <li>6 x LED - Green LED bulb with charge</li>
                                <li>Bidirectional</li>
                                <li>Fire Exit</li>
                                <li>Continuous Lighting, Working Time in Power Failure 3 Hours</li>
                                <li>Power Consumption: 3W</li>
                                <li>Supply Voltage: 220V AC</li>
                                <li>IP20</li>
                                <li>Aluminum Case, Glass Surface</li>
                                <li>With Power/Charging/Error Indicator</li>
                                <li>Test Button</li>
                                <li>1.2V 600mA Rechargeable Ni-Cd Battery</li>
                                <li>Brightness: 56-130 cd/m2</li>
                                <li>Certifications: CE </li>
                                <li>Package Quantity: 20 </li>
                            </ul>
                        </figure>

                    </div>
                },
                {
                    id: 26,
                    name: 'VERSALITE EMERGENCY LIGHT',
                    imgsrc: [
                        process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/image-271.png',
                        process.env.PUBLIC_URL + '/images/products/acil_aydinlatma_ve_yonlendirme_armaturleri/image-268.png'
                    ],
                    content: '',
                    link: '/product/12/26/acil_aydinlatma_ve_yonlendirme_armaturleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <p>Versalite emergency lighting fixture can be used as fixed and mobile. It provides suitable lighting in long corridors, stairwells, wide usage areas such as parking lots and factories. In spot lighting, the luminaire is activated only in case of power cut. There is an LED on the device that indicates the presence of mains voltage and the state of charge of the battery. Maintenance-free dry type batteries are used in all models. Mains supply voltage is standard 220 volts AC, +/- 8% dr. In models with batteries, the charging time is at least 24 hours at first use.
                            </p>
                        </figure>
                        <figure>
                            <figcaption>luminaires</figcaption>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Combustion Status</th>
                                        <th>Usage</th>
                                        <th>Lamp</th>
                                        <th>Battery</th>
                                        <th>Duration</th>
                                        <th>Dimensions (Width-Length-Height)</th>
                                        <th>Weight</th>
                                        <th>Ip Class</th>
                                        <th>Insulation Class</th>
                                        <th>Operating temperature</th>
                                        <th>Power consumption</th>
                                        <th>Operating voltage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>VSL-201-18</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x18 LED</td>
                                        <td>12V/1,2AH</td>
                                        <td>60 in interruption</td>
                                        <td>95x352x300mm</td>
                                        <td>3,8 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>3,5w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VSL-203-18</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x18 LED</td>
                                        <td>12V/2,3AH</td>
                                        <td>180 in interruption</td>
                                        <td>95x352x300mm</td>
                                        <td>4,2 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>3,5w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VSL-201-36</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x36 LED</td>
                                        <td>12V/1,2AH</td>
                                        <td>60 in interruption</td>
                                        <td>95x352x300mm</td>
                                        <td>4,2 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>3,5w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VSL-203-36</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x36 LED</td>
                                        <td>12V/4,5AH</td>
                                        <td>180 in interruption</td>
                                        <td>95x352x300mm</td>
                                        <td>4,75 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>3,5w</td>
                                        <td>220-240</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Combustion Status</th>
                                        <th>Usage</th>
                                        <th>Lamp</th>
                                        <th>Illuminated Surface</th>
                                        <th>Duration</th>
                                        <th>Dimensions (Width-Length-Height)</th>
                                        <th>Weight</th>
                                        <th>Ip Sınıfı</th>
                                        <th>Insulation Class</th>
                                        <th>Operating temperature</th>
                                        <th>Power consumption</th>
                                        <th>Operating voltage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>VS-2201</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x20 wat</td>
                                        <td>Moving</td>
                                        <td>60 in interruption</td>
                                        <td>110x370x412mm</td>
                                        <td>7,45 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>10w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VS-2202</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x20 wat</td>
                                        <td>Moving</td>
                                        <td>120 in interruption</td>
                                        <td>110x370x412mm</td>
                                        <td>7,45 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>10w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VS-2203</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x20 wat</td>
                                        <td>Moving</td>
                                        <td>180 in interruption</td>
                                        <td>110x370x412mm</td>
                                        <td>9 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>10w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VS-2351</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x35 wat</td>
                                        <td>Moving</td>
                                        <td>60 in interruption</td>
                                        <td>110x370x412mm</td>
                                        <td>7,45 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>10w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VS-2352</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x35 wat</td>
                                        <td>Moving</td>
                                        <td>120 in interruption</td>
                                        <td>110x370x412mm</td>
                                        <td>9 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>10w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VS-2353</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x35 wat</td>
                                        <td>Moving</td>
                                        <td>180 in interruption</td>
                                        <td>180x370x412mm</td>
                                        <td>14 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>50w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VS-2501</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x50 wat</td>
                                        <td>Moving</td>
                                        <td>60 in interruption</td>
                                        <td>110x370x412mm</td>
                                        <td>9 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>10w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VS-2501.5</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x50 wat</td>
                                        <td>Moving</td>
                                        <td>90 in interruption</td>
                                        <td>110x370x412mm</td>
                                        <td>11,8 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>10w</td>
                                        <td>220-240</td>
                                    </tr>
                                    <tr>
                                        <td>VS-2503</td>
                                        <td>Burning in Interruption</td>
                                        <td>Wall Mount</td>
                                        <td>2x50 wat</td>
                                        <td>Moving</td>
                                        <td>180 in interruption</td>
                                        <td>180x370x412mm</td>
                                        <td>15 kg</td>
                                        <td>40</td>
                                        <td>I</td>
                                        <td>-16/+45C</td>
                                        <td>50w</td>
                                        <td>220-240</td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </div>
                },
            ]
        }
    }
    ,
    {
        category: {
            id: 13,
            name: 'FIRE PROTECTIVE EQUIPMENT',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/Nomex-İtfaiyeci-Elbisesi-YANMAZ-mavi-renk.png'],
            content: "FIRE RESISTANT LEATHER FIRE MAN'S GLOVES,FIRE MAN’S BOOTS,FIRE MAN’S HOOD",
            link: '/category/yangin_koruyucu_ekipmanlari/13/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'MASKS AND FILTERS',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/image-291.png'],
                    content: '',
                    link: false,
                },
                {
                    id: 1,
                    name: 'SCREW MOUNT CARBON MONOXIDE FILTER',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/image-292.png'],
                    content: '',
                    link: false,
                },
                {
                    id: 2,
                    name: 'COOLING VEST',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/image-293.png'],
                    content: '',
                    link: false,
                },
                {
                    id: 3,
                    name: "FIRE RESISTANT LEATHER FIRE MAN'S GLOVES",
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/image-295.png'],
                    content: '',
                    link: false,
                },
                {
                    id: 4,
                    name: "FIRE MAN’S BOOTS",
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/image-288.png'],
                    content: '',
                    link: false,
                },
                {
                    id: 5,
                    name: "FIRE MAN’S HOOD",
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/image-289.png'],
                    content: '',
                    link: false,
                },
                {
                    id: 6,
                    name: "FIRE MAN’S HELMET",
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/image-287.png'],
                    content: '',
                    link: false,
                },
                {
                    id: 7,
                    name: "FIRE BLANKET",
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/image-285.png'],
                    content: '',
                    link: false,
                },
                {
                    id: 8,
                    name: 'CHEMICAL PROTECTIVE CLOTHING',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/image-290.png'],
                    content: '',
                    link: false,
                },
                {
                    id: 9,
                    name: "FIRE MAN’S CLOTHING",
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_koruyucu_ekipmanlari/Nomex-İtfaiyeci-Elbisesi-YANMAZ-mavi-renk.png'],
                    content: '',
                    link: false,
                },
            ]
        }
    }
    ,
    {
        category: {
            id: 14,
            name: 'FIRE PUMPS',
            imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_pompalari/image-296.png'],
            content: 'Fire pumps conforming to NFPA 20 and Turkish standards.',
            link: '/category/yanginhortumlari/14/subcategories',
            subcategories: [
                {
                    id: 0,
                    name: 'FIRE PUMPS',
                    imgsrc: [process.env.PUBLIC_URL + '/images/products/yangin_pompalari/image-296.png'],
                    content: '',
                    link: '/product/14/0/otomatik_davlumbaz_sondurme_sistemleri',
                    detail: <div className="detail">
                        <h2>Technical Details</h2>
                        <figure>
                            <figcaption>Fire Pump Types</figcaption>
                            <ul>
                                <li>End Suction Fire Pumps</li>
                                <li>Detachable Body Centrifugal Fire Pumps</li>
                                <li>Line Type Fire Pumps</li>
                                <li>Vertical shaft fire pumps</li>
                            </ul>
                        </figure>
                        <figure>
                            <figcaption>Working Principle of Fire Pumps</figcaption>
                            <p>The fire pump should be selected to meet the pressure and flow required during a fire; This is one of the critical points in choosing a fire pump. Fire pump systems consist of a main and a backup pump. In this sense, it is an important detail to project the main fire pumps as redundant, because in case of possible risks, a plan B is always required. The fire pumps used in fire extinguishing systems are controlled by a control panel. A separate control panel for each fire pump, these panels are located in accordance with the relevant standards and regulations.</p>
                            <p>Electric motor driven or diesel fire pumps can be used in fire extinguishing systems. If the system pressure in the fire extinguishing installation falls below the value set by the pressure switch at the fire pump, the fire pump is activated automatically. Signal information comes from the pressure switch and this information is transmitted to the control panel. The fire pump is activated according to the incoming pressure information and is deactivated when necessary with the stop switch on the control panel.
                            </p>
                        </figure>

                    </div>
                },
            ]
        }
    }
]

export default data;